"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get Altered () {
        return Altered;
    },
    get ColumnsService () {
        return ColumnsService;
    },
    get getJunctionTableName () {
        return getJunctionTableName;
    },
    get reuseOrSave () {
        return reuseOrSave;
    }
});
const _common = require("@nestjs/common");
const _inflection = require("inflection");
const _nocodbsdk = require("nocodb-sdk");
const _rfdc = /*#__PURE__*/ _interop_require_default(require("rfdc"));
const _columnwebhookmanager = require("~/utils/column-webhook-manager");
const _dbHelpers = require("~/helpers/dbHelpers");
const _genRollupSelectv2 = /*#__PURE__*/ _interop_require_default(require("~/db/genRollupSelectv2"));
const _formulaQueryBuilderv2 = /*#__PURE__*/ _interop_require_default(require("~/db/formulav2/formulaQueryBuilderv2"));
const _ProjectMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/db/sql-mgr/v2/ProjectMgrv2"));
const _helpers = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _extractProps = require("~/helpers/extractProps");
const _getColumnPropsFromUIDT = /*#__PURE__*/ _interop_require_default(require("~/helpers/getColumnPropsFromUIDT"));
const _getUniqueName = require("~/helpers/getUniqueName");
const _mapDefaultDisplayValue = /*#__PURE__*/ _interop_require_default(require("~/helpers/mapDefaultDisplayValue"));
const _validateParams = /*#__PURE__*/ _interop_require_default(require("~/helpers/validateParams"));
const _metaservice = require("~/meta/meta.service");
const _models = require("~/models");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _formulacolumntypechangertypes = require("~/services/formula-column-type-changer.types");
const _viewrowcolorservice = require("~/services/view-row-color.service");
const _filtersservice = require("~/services/filters.service");
const _duplicatedetectionservice = require("~/services/duplicate-detection.service");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _uniqueConstraintHelpers = require("~/helpers/uniqueConstraintHelpers");
const _dataConversion = require("~/utils/dataConversion");
const _globals = require("~/utils/globals");
const _modelUtils = require("~/utils/modelUtils");
const _NocoSocket = /*#__PURE__*/ _interop_require_default(require("~/socket/NocoSocket"));
const _extractor = require("~/helpers/db-error/extractor");
const _eventhandlerservice = require("~/services/meta-dependency/event-handler.service");
const _getRelatedModelMap = require("~/utils/getRelatedModelMap");
const _columninternalmeta = require("~/types/column-internal-meta");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
const deepClone = (0, _rfdc.default)();
var Altered = /*#__PURE__*/ function(Altered) {
    Altered[Altered["NEW_COLUMN"] = 1] = "NEW_COLUMN";
    Altered[Altered["DELETE_COLUMN"] = 4] = "DELETE_COLUMN";
    Altered[Altered["UPDATE_COLUMN"] = 8] = "UPDATE_COLUMN";
    return Altered;
}({});
async function reuseOrSave(tp, params, get) {
    if (params[tp]) {
        return params[tp];
    }
    const res = await get();
    params[tp] = res;
    return res;
}
async function getJunctionTableName(param, parent, child) {
    var _ref;
    var _param_base, _param_base1, _param_base2, _param_base3, _param_base4;
    const parentTable = ((_param_base = param.base) == null ? void 0 : _param_base.prefix) ? parent.table_name.replace(`${(_param_base1 = param.base) == null ? void 0 : _param_base1.prefix}_`, '') : parent.table_name;
    const childTable = ((_param_base2 = param.base) == null ? void 0 : _param_base2.prefix) ? child.table_name.replace(`${(_param_base3 = param.base) == null ? void 0 : _param_base3.prefix}_`, '') : child.table_name;
    const tableName = `${(_ref = (_param_base4 = param.base) == null ? void 0 : _param_base4.prefix) != null ? _ref : ''}_nc_m2m_${parentTable.slice(0, 15)}_${childTable.slice(0, 15)}`;
    let suffix = null;
    // check table name avail or not, if not then add incremental suffix
    while(await _Noco.default.ncMeta.metaGet2(parent.fk_workspace_id, parent.base_id, _globals.MetaTable.MODELS, {
        table_name: `${tableName}${suffix != null ? suffix : ''}`,
        source_id: parent.source_id
    })){
        suffix = suffix ? suffix + 1 : 1;
    }
    return `${tableName}${suffix != null ? suffix : ''}`;
}
const generateColumnDeleteHandler = (columnWebhookManager)=>{
    if (!columnWebhookManager) {
        return {};
    }
    return {
        beforeRelatedColumnDelete: async (context, columnId)=>{
            await columnWebhookManager.addOldColumnById({
                columnId,
                action: _nocodbsdk.WebhookActions.DELETE,
                context
            });
        },
        beforeRelatedColumnUpdate: async (context, columnId)=>{
            await columnWebhookManager.addOldColumnById({
                columnId,
                action: _nocodbsdk.WebhookActions.UPDATE,
                context
            });
        }
    };
};
let ColumnsService = class ColumnsService {
    /**
   * Stores unique constraint name in internal_meta field when enabling unique constraint.
   * This ensures we can drop the constraint even if table/column name changes later.
   * internal_meta is an internal field (not exposed via API)
   *
   * @param context - NcContext
   * @param column - Partial Column object containing base_id, fk_model_id, id, and internal_meta
   * @returns Updated internal_meta object with unique_constraint_name set
   */ storeUniqueConstraintNameInInternalMeta(context, column) {
        // Generate constraint name using base_id + '_' + table_id + '_' + column_id for fixed-length, unique constraint name
        // For new columns, column.id might be a temporary identifier (like column name) that will be updated after insertion
        const constraintName = `uk_${column.base_id}_${column.fk_model_id}_${column.id}`;
        // Parse existing internal_meta or create new object
        let internalMeta = column.internal_meta;
        if (typeof internalMeta === 'string') {
            try {
                internalMeta = JSON.parse(internalMeta);
            } catch (unused) {
                internalMeta = {};
            }
        } else if (!internalMeta) {
            internalMeta = {};
        }
        // Validate internal_meta structure
        (0, _columninternalmeta.validateColumnInternalMeta)(internalMeta);
        // Store constraint name in internal_meta field
        internalMeta.unique_constraint_name = constraintName;
        return internalMeta;
    }
    async updateFormulas(context, args) {
        const { oldColumn, colBody } = args;
        // update formula if column name or title is changed
        if (oldColumn.column_name !== colBody.column_name || oldColumn.title !== colBody.title) {
            const formulas = await _Noco.default.ncMeta.knex(_globals.MetaTable.COL_FORMULA).where('formula', 'like', `%${oldColumn.id}%`);
            if (formulas) {
                oldColumn.column_name = colBody.column_name;
                oldColumn.title = colBody.title;
                for (const f of formulas){
                    // replace column IDs with alias to get the new formula_raw
                    const new_formula_raw = (0, _nocodbsdk.substituteColumnIdWithAliasInFormula)(f.formula, [
                        oldColumn
                    ]);
                    // update the formula_raw and set parsed_tree to null to reparse the formula
                    await _models.FormulaColumn.update(context, oldColumn.id, {
                        formula_raw: new_formula_raw,
                        parsed_tree: null
                    });
                }
            }
        }
    }
    async updateMetaAndDatabase(context, args) {
        const { table, column, source, reuse } = args;
        const tableUpdateBody = _extends({}, table, {
            tn: table.table_name,
            originalColumns: table.columns.map((c)=>_extends({}, c, {
                    cn: c.column_name,
                    cno: c.column_name
                })),
            columns: await Promise.all(table.columns.map(async (c)=>{
                if (c.id === column.id) {
                    // Determine unique value: use column.unique if provided, otherwise preserve existing value
                    const uniqueValue = column.unique !== undefined ? column.unique : c.unique !== undefined ? c.unique : false;
                    const res = _extends({}, c, column, {
                        // Use column.column_name if provided and not empty, otherwise use existing column name
                        // This ensures we don't accidentally rename the column when only updating other properties
                        // Always set cn to the existing column name if column_name is not explicitly provided
                        cn: column.column_name !== undefined && column.column_name !== null && column.column_name !== '' ? column.column_name : c.column_name,
                        // cno should always be the original column name (before any potential rename)
                        cno: c.column_name,
                        altered: 8,
                        unique: uniqueValue
                    });
                    // Ensure cn and cno are set correctly - if not renaming, they should be the same
                    if (!res.cn) {
                        res.cn = res.cno;
                    }
                    if (args.processColumn) {
                        await args.processColumn();
                    }
                    return Promise.resolve(res);
                } else {
                    c.cn = c.column_name;
                }
                return Promise.resolve(c);
            }))
        });
        const sqlMgr = await reuseOrSave('sqlMgr', reuse, async ()=>_ProjectMgrv2.default.getSqlMgr(context, {
                id: source.base_id
            }));
        await sqlMgr.sqlOpPlus(source, 'tableUpdate', tableUpdateBody);
        await _models.Column.update(context, column.id, _extends({}, column));
    }
    async columnUpdate(context, param, ncMeta = _Noco.default.ncMeta) {
        var _param_columnWebhookManager;
        const reuse = param.reuse || {};
        const { req } = param;
        const column = await _models.Column.get(context, {
            colId: param.columnId
        });
        const oldColumn = deepClone(column);
        const table = await reuseOrSave('table', reuse, async ()=>_models.Model.getWithInfo(context, {
                id: column.fk_model_id
            }));
        const isSyncedColumn = table.synced && column.readonly;
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        const source = await reuseOrSave('source', reuse, async ()=>_models.Source.get(context, table.source_id));
        const columnWebhookManager = (_param_columnWebhookManager = param.columnWebhookManager) != null ? _param_columnWebhookManager : (await (await new _columnwebhookmanager.ColumnWebhookManagerBuilder(context, ncMeta).withModelId(column.fk_model_id)).addColumnById(column.id)).forUpdate();
        // TODO: Refactor the columnUpdate function to handle metaOnly changes and
        // DB related changes, right now both are mixed up, making this fragile
        if (param.column.description !== column.description) {
            await _models.Column.update(context, param.columnId, {
                description: param.column.description
            });
        }
        // These are the column types whose meta is allowed to be updated
        // It includes currency, date, datetime where formatting is allowed to update
        const isMetaOnlyUpdateAllowed = ((source == null ? void 0 : source.is_schema_readonly) || isSyncedColumn) && _nocodbsdk.partialUpdateAllowedTypes.includes(column.uidt);
        // check if source is readonly and column type is not allowed
        if (((source == null ? void 0 : source.is_schema_readonly) || isSyncedColumn) && (!_nocodbsdk.readonlyMetaAllowedTypes.includes(column.uidt) || param.column.uidt && !_nocodbsdk.readonlyMetaAllowedTypes.includes(param.column.uidt)) && !_nocodbsdk.partialUpdateAllowedTypes.includes(column.uidt)) {
            /*
      throw error if source is readonly and column type is not allowed
      NcError.sourceMetaReadOnly(source.alias);

      Get all the columns in the table and return
      */ await table.getColumns(context);
            const updatedColumn = await _models.Column.get(context, {
                colId: param.columnId
            });
            this.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_UPDATE, {
                table,
                oldColumn,
                column: updatedColumn,
                columnId: column.id,
                req: param.req,
                context,
                columns: table.columns
            });
            return table;
        }
        const sqlClient = await reuseOrSave('sqlClient', reuse, async ()=>_NcConnectionMgrv2.default.getSqlClient(source));
        const sqlClientType = sqlClient.knex.clientType();
        // The maxLength of column name is different for different databases
        // This is the maximum length of column name allowed in the database
        const mxColumnLength = _models.Column.getMaxColumnNameLength(sqlClientType);
        if (!(0, _nocodbsdk.isVirtualCol)(param.column) && !isMetaOnlyUpdateAllowed && param.column.column_name) {
            param.column.column_name = (0, _helpers.sanitizeColumnName)(param.column.column_name, source.type);
        }
        // trim leading and trailing spaces from column title as knex trim them by default
        if (param.column.title) {
            param.column.title = param.column.title.trim();
        }
        if (param.column.column_name && !isMetaOnlyUpdateAllowed) {
            // - 5 is a buffer for suffix
            let colName = param.column.column_name.slice(0, mxColumnLength - 5);
            let suffix = 1;
            while(!await _models.Column.checkTitleAvailable(context, {
                column_name: colName,
                fk_model_id: column.fk_model_id,
                exclude_id: param.columnId
            })){
                colName = param.column.column_name.slice(0, mxColumnLength - 5);
                colName += `_${suffix++}`;
            }
            param.column.column_name = colName;
        }
        if (!isMetaOnlyUpdateAllowed && !(0, _nocodbsdk.isVirtualCol)(param.column) && param.column.column_name && param.column.column_name.length > mxColumnLength) {
            _catchError.NcError.get(context).invalidRequestBody(`Column name ${param.column.column_name} exceeds ${mxColumnLength} characters`);
        }
        if (param.column.title && param.column.title.length > 255) {
            _catchError.NcError.get(context).invalidRequestBody(`Column title ${param.column.title} exceeds 255 characters`);
        }
        if (param.column.column_name && !(0, _nocodbsdk.isVirtualCol)(param.column) && !(0, _nocodbsdk.isCreatedOrLastModifiedTimeCol)(param.column) && !(0, _nocodbsdk.isCreatedOrLastModifiedByCol)(param.column) && !await _models.Column.checkTitleAvailable(context, {
            column_name: param.column.column_name,
            fk_model_id: column.fk_model_id,
            exclude_id: param.columnId
        })) {
            _catchError.NcError.get(context).duplicateAlias({
                type: 'column',
                alias: param.column.column_name,
                base: context.base_id,
                label: 'name',
                additionalTrace: {
                    table: column.fk_model_id
                }
            });
        }
        if (param.column.title && !await _models.Column.checkAliasAvailable(context, {
            title: param.column.title,
            fk_model_id: column.fk_model_id,
            exclude_id: param.columnId
        })) {
            // This error will be thrown if there are more than one column linking to the same table. You have to delete one of them
            _catchError.NcError.get(context).duplicateAlias({
                type: 'column',
                alias: param.column.title,
                base: context.base_id,
                additionalTrace: {
                    table: column.fk_model_id
                }
            });
        }
        const sqlUi = _nocodbsdk.SqlUiFactory.create(await source.getConnectionConfig());
        // for API call, if dt is not supplied
        // but uidt is present
        // and uidt is different, try to get dt from uidt
        if (param.column.uidt && param.column.uidt !== column.uidt && !param.column.dt && // if uidt is invalid, do not try to set default dt
        Object.values(_nocodbsdk.UITypes).includes(param.column.uidt)) {
            var _sqlUi_getDataTypeForUiType, _column_meta;
            param.column.dt = (_sqlUi_getDataTypeForUiType = sqlUi.getDataTypeForUiType({
                uidt: param.column.uidt
            }, (column == null ? void 0 : (_column_meta = column['meta']) == null ? void 0 : _column_meta['ag']) ? 'AG' : 'AI')) == null ? void 0 : _sqlUi_getDataTypeForUiType.dt;
        } else if (param.column.uidt && param.column.uidt !== column.uidt && param.column.dt && // if uidt is invalid, do not try to set default dt
        Object.values(_nocodbsdk.UITypes).includes(param.column.uidt)) {
            const dtList = sqlUi.getDataTypeListForUiType(param.column);
            if (!dtList.includes(param.column.dt)) {
                var _sqlUi_getDataTypeForUiType1, _column_meta1;
                param.column.dt = (_sqlUi_getDataTypeForUiType1 = sqlUi.getDataTypeForUiType({
                    uidt: param.column.uidt
                }, (column == null ? void 0 : (_column_meta1 = column['meta']) == null ? void 0 : _column_meta1['ag']) ? 'AG' : 'AI')) == null ? void 0 : _sqlUi_getDataTypeForUiType1.dt;
            }
        }
        // extract missing required props from column to avoid broken column
        param.column = _extends({}, (0, _extractProps.extractProps)(column, [
            'column_name',
            'uidt',
            'dt'
        ]), param.column);
        // Validate unique constraint for column updates
        if ('unique' in param.column) {
            // Check if disabling unique constraint (always allowed)
            if (!param.column.unique && column.unique) {
            // Disabling is allowed, no validation needed
            } else if (param.column.unique && column.unique) {
            // no validation needed
            } else if (param.column.unique) {
                // Enabling unique constraint enabled
                (0, _uniqueConstraintHelpers.validateUniqueConstraint)(context, param.column.uidt || column.uidt, param.column.meta || column.meta, !!param.column.unique, source, param.column.cdf !== undefined ? param.column.cdf : column.cdf);
                // Check for existing duplicates if enabling unique constraint
                if (!column.unique && param.column.unique) {
                    const duplicateCheck = await this.duplicateDetectionService.checkForDuplicates(context, column);
                    if (duplicateCheck.hasDuplicates) {
                        _catchError.NcError.get(context).badRequest(`Found ${duplicateCheck.count} duplicate values in this field. Please edit or remove duplicates before enabling uniqueness.`);
                    }
                }
            }
        }
        // Check if default value is being set when unique constraint is enabled
        // Exclude UUID fields which are allowed to have both unique constraint and auto-generation
        // Also check the original column type to handle cases where uidt might not be sent in the update request
        const isUUIDColumn = (param.column.uidt || column.uidt) === _nocodbsdk.UITypes.UUID || column.uidt === _nocodbsdk.UITypes.UUID;
        if ('cdf' in param.column && param.column.cdf !== null && param.column.cdf !== undefined && param.column.cdf !== '' && !isUUIDColumn) {
            const currentUnique = param.column.unique !== undefined ? param.column.unique : column.unique;
            if (currentUnique) {
                _catchError.NcError.get(context).badRequest('Default values are not allowed for unique fields. Please disable the unique constraint first.');
            }
        }
        let colBody = _extends({}, param.column);
        sqlUi.adjustLengthAndScale(colBody);
        // Store unique constraint name in internal_meta field when enabling unique constraint
        // This ensures we can drop the constraint even if table/column name changes later
        // internal_meta is an internal field (not exposed via API)
        if (param.column.unique && !column.unique) {
            // Enabling unique constraint - generate and store constraint name
            const internalMeta = this.storeUniqueConstraintNameInInternalMeta(context, column);
            // Store in colBody (will be saved to database)
            colBody.internal_meta = internalMeta;
        }
        const { applyRowColorInvolvement } = await this.viewRowColorService.checkIfColumnInvolved({
            context,
            existingColumn: oldColumn,
            newColumn: colBody,
            action: 'update'
        });
        if (isMetaOnlyUpdateAllowed || (0, _nocodbsdk.isCreatedOrLastModifiedTimeCol)(column) || (0, _nocodbsdk.isCreatedOrLastModifiedByCol)(column) || [
            _nocodbsdk.UITypes.Lookup,
            _nocodbsdk.UITypes.Rollup,
            _nocodbsdk.UITypes.LinkToAnotherRecord,
            _nocodbsdk.UITypes.Formula,
            _nocodbsdk.UITypes.QrCode,
            _nocodbsdk.UITypes.Barcode,
            _nocodbsdk.UITypes.ForeignKey,
            _nocodbsdk.UITypes.Links,
            _nocodbsdk.UITypes.Button
        ].includes(column.uidt)) {
            if (column.uidt === colBody.uidt) {
                if ([
                    _nocodbsdk.UITypes.QrCode,
                    _nocodbsdk.UITypes.Barcode
                ].includes(column.uidt)) {
                    await _models.Column.update(context, column.id, _extends({}, column, colBody));
                } else if (column.uidt === _nocodbsdk.UITypes.Formula) {
                    const relatedModels = await (0, _getRelatedModelMap.getRelatedModelMap)(context, table);
                    colBody.formula = await (0, _nocodbsdk.substituteColumnAliasWithIdInFormula)(colBody.formula_raw || colBody.formula, table.columns);
                    colBody.parsed_tree = await (0, _nocodbsdk.validateFormulaAndExtractTreeWithType)({
                        formula: colBody.formula || colBody.formula_raw,
                        columns: table.columns,
                        column,
                        clientOrSqlUi: source.type,
                        getMeta: async (_, { id })=>{
                            return relatedModels.get(id);
                        }
                    });
                    try {
                        const baseModel = await reuseOrSave('baseModel', reuse, async ()=>_models.Model.getBaseModelSQL(context, {
                                id: table.id,
                                dbDriver: await reuseOrSave('dbDriver', reuse, async ()=>_NcConnectionMgrv2.default.get(source))
                            }));
                        await (0, _formulaQueryBuilderv2.default)({
                            baseModel: baseModel,
                            tree: colBody.formula,
                            model: table,
                            column,
                            validateFormula: true,
                            parsedTree: colBody.parsed_tree
                        });
                    } catch (e) {
                        if (e instanceof _catchError.NcError || e instanceof _nocodbsdk.NcBaseError) throw e;
                        this.logger.error('Error updating column', e);
                        _catchError.NcError.get(context).internalServerError('Failed to update column');
                    }
                    await _models.Column.update(context, column.id, _extends({}, column, colBody));
                } else if (column.uidt === _nocodbsdk.UITypes.Button) {
                    if (colBody.type === _nocodbsdk.ButtonActionsType.Url) {
                        const relatedModels = await (0, _getRelatedModelMap.getRelatedModelMap)(context, table);
                        colBody.formula = await (0, _nocodbsdk.substituteColumnAliasWithIdInFormula)(colBody.formula_raw || colBody.formula, table.columns);
                        colBody.parsed_tree = await (0, _nocodbsdk.validateFormulaAndExtractTreeWithType)({
                            formula: colBody.formula || colBody.formula_raw,
                            columns: table.columns,
                            column,
                            clientOrSqlUi: source.type,
                            getMeta: async (_, { id })=>{
                                return relatedModels.get(id);
                            }
                        });
                        try {
                            const baseModel = await reuseOrSave('baseModel', reuse, async ()=>_models.Model.getBaseModelSQL(context, {
                                    id: table.id,
                                    dbDriver: await reuseOrSave('dbDriver', reuse, async ()=>_NcConnectionMgrv2.default.get(source))
                                }));
                            await (0, _formulaQueryBuilderv2.default)({
                                baseModel: baseModel,
                                tree: colBody.formula,
                                model: table,
                                column: null,
                                validateFormula: true,
                                parsedTree: colBody.parsed_tree
                            });
                        } catch (e) {
                            console.error(e);
                            _catchError.NcError.get(context).badRequest('Invalid Formula');
                        }
                    } else if (colBody.type === _nocodbsdk.ButtonActionsType.Webhook) {
                        var _hook_operation;
                        if (!colBody.fk_webhook_id) {
                            _catchError.NcError.get(context).badRequest('Webhook not found');
                        }
                        const hook = await _models.Hook.get(context, colBody.fk_webhook_id);
                        if (!hook || !hook.active || hook.version !== 'v3' && hook.event === 'manual' || hook.version === 'v3' && !((_hook_operation = hook.operation) == null ? void 0 : _hook_operation.includes('trigger'))) {
                            _catchError.NcError.get(context).badRequest('Webhook not found');
                        }
                    } else if (colBody.type === _nocodbsdk.ButtonActionsType.Script) {
                        if (!colBody.fk_script_id) {
                            _catchError.NcError.get(context).badRequest('Script not found');
                        }
                        const script = await _models.Script.get(context, colBody.fk_script_id);
                        if (!script) {
                            _catchError.NcError.get(context).badRequest('Script not found');
                        }
                    } else if (colBody.type === _nocodbsdk.ButtonActionsType.Ai) {
                        /*
              Substitute column alias with id in prompt
            */ if (colBody.formula_raw) {
                            await table.getColumns(context);
                            colBody.formula = colBody.formula_raw.replace(/{(.*?)}/g, (match, p1)=>{
                                const column = table.columns.find((c)=>c.title === p1);
                                if (!column) {
                                    _catchError.NcError.get(context).badRequest(`Field '${p1}' not found`);
                                }
                                return `{${column.id}}`;
                            });
                        }
                    }
                    await _models.Column.update(context, column.id, _extends({}, column, colBody));
                } else {
                    var _colBody_column_order, _colBody_column_order1;
                    if (colBody.title !== column.title) {
                        await _models.Column.updateAlias(context, param.columnId, {
                            title: colBody.title
                        });
                    }
                    if ('meta' in colBody && ([
                        _nocodbsdk.UITypes.CreatedTime,
                        _nocodbsdk.UITypes.LastModifiedTime
                    ].includes(column.uidt) || isMetaOnlyUpdateAllowed)) {
                        await _models.Column.updateMeta(context, {
                            colId: param.columnId,
                            meta: colBody.meta
                        });
                    }
                    if ('validate' in colBody && ([
                        _nocodbsdk.UITypes.URL,
                        _nocodbsdk.UITypes.PhoneNumber,
                        _nocodbsdk.UITypes.Email
                    ].includes(column.uidt) || isMetaOnlyUpdateAllowed)) {
                        await _models.Column.updateValidation(context, {
                            colId: param.columnId,
                            validate: colBody.validate
                        });
                    }
                    if ((0, _nocodbsdk.isLinksOrLTAR)(column)) {
                        var _colBody_colOptions, _colBody_colOptions1;
                        if ('meta' in colBody) {
                            await _models.Column.updateMeta(context, {
                                colId: param.columnId,
                                meta: _extends({}, column.meta, colBody.meta)
                            });
                        }
                        await _models.View.clearSingleQueryCache(context, column.fk_model_id, null);
                        // check alias value present in colBody
                        if (colBody.childViewId === null || colBody.childViewId) {
                            colBody.colOptions = colBody.colOptions || {};
                            colBody.colOptions.fk_target_view_id = colBody.childViewId;
                        }
                        if (((_colBody_colOptions = colBody.colOptions) == null ? void 0 : _colBody_colOptions.fk_target_view_id) || ((_colBody_colOptions1 = colBody.colOptions) == null ? void 0 : _colBody_colOptions1.fk_target_view_id) === null) {
                            await _models.Column.updateTargetView(context, {
                                colId: param.columnId,
                                fk_target_view_id: colBody.colOptions.fk_target_view_id
                            });
                        }
                    }
                    // handle reorder column
                    if ((colBody == null ? void 0 : colBody.column_order) && ((_colBody_column_order = colBody.column_order) == null ? void 0 : _colBody_column_order.order) && ((_colBody_column_order1 = colBody.column_order) == null ? void 0 : _colBody_column_order1.view_id)) {
                        const viewColumn = (await _models.View.getColumns(context, colBody.column_order.view_id)).find((col)=>col.fk_column_id === column.id);
                        await _models.View.updateColumn(context, colBody.column_order.view_id, viewColumn.id, {
                            order: colBody.column_order.order
                        });
                    }
                }
                await this.updateRollupOrLookup(context, colBody, column);
            } else if ([
                _nocodbsdk.UITypes.Formula
            ].includes(column.uidt)) {
                param.column.id = undefined;
                await this.formulaColumnTypeChanger.startChangeFormulaColumnType(context, {
                    req,
                    formulaColumn: column,
                    newColumnRequest: param.column,
                    user: param.user,
                    reuse: param.reuse
                });
            } else {
                _catchError.NcError.get(context).notImplemented(`Updating ${column.uidt} => ${colBody.uidt}`);
            }
        } else if ([
            _nocodbsdk.UITypes.Lookup,
            _nocodbsdk.UITypes.Rollup,
            _nocodbsdk.UITypes.LinkToAnotherRecord,
            _nocodbsdk.UITypes.Formula,
            _nocodbsdk.UITypes.QrCode,
            _nocodbsdk.UITypes.Barcode,
            _nocodbsdk.UITypes.ForeignKey
        ].includes(colBody.uidt)) {
            _catchError.NcError.get(context).notImplemented(`Updating ${colBody.uidt} => ${colBody.uidt}`);
        } else if ([
            _nocodbsdk.UITypes.CreatedTime,
            _nocodbsdk.UITypes.LastModifiedTime,
            _nocodbsdk.UITypes.CreatedBy,
            _nocodbsdk.UITypes.LastModifiedBy
        ].includes(colBody.uidt)) {
            if (isSyncedColumn) {
                _catchError.NcError.get(context).invalidRequestBody(`The column '${column.title || column.column_name}' is a synced column and cannot be updated.`);
            }
            // allow updating of title only
            await _models.Column.update(context, param.columnId, _extends({}, column, {
                title: colBody.title
            }));
        } else if ([
            _nocodbsdk.UITypes.SingleSelect,
            _nocodbsdk.UITypes.MultiSelect
        ].includes(colBody.uidt)) {
            var _colBody_colOptions2, _column_colOptions, _colBody_colOptions3;
            if (isSyncedColumn) {
                _catchError.NcError.get(context).invalidRequestBody(`The column '${column.title || column.column_name}' is a synced column and cannot be updated.`);
            }
            colBody = await (0, _getColumnPropsFromUIDT.default)(colBody, source);
            // Preserve existing colOptions when the request doesn't include them.
            // Without this, a metadata-only PATCH (e.g. updating description) would
            // skip the options-processing block entirely or cause options to be wiped
            // when Column.update deletes and re-inserts colOptions.
            if (!((_colBody_colOptions2 = colBody.colOptions) == null ? void 0 : _colBody_colOptions2.options) && ((_column_colOptions = column.colOptions) == null ? void 0 : _column_colOptions.options)) {
                colBody.colOptions = column.colOptions;
            }
            const baseModel = await reuseOrSave('baseModel', reuse, async ()=>_models.Model.getBaseModelSQL(context, {
                    id: table.id,
                    dbDriver: await reuseOrSave('dbDriver', reuse, async ()=>_NcConnectionMgrv2.default.get(source))
                }));
            if ((_colBody_colOptions3 = colBody.colOptions) == null ? void 0 : _colBody_colOptions3.options) {
                var _column_colOptions1, _column_colOptions2, _column_colOptions3;
                const supportedDrivers = [
                    'mysql',
                    'mysql2',
                    'pg',
                    'sqlite3'
                ];
                const dbDriver = await reuseOrSave('dbDriver', reuse, async ()=>_NcConnectionMgrv2.default.get(source));
                const driverType = dbDriver.clientType();
                if (column.uidt === _nocodbsdk.UITypes.SingleSelect && colBody.uidt !== _nocodbsdk.UITypes.SingleSelect) {
                    if ((await _models.KanbanView.getViewsByGroupingColId(context, column.id)).length > 0) {
                        _catchError.NcError.get(context).badRequest(`The column '${column.title}' is being used in Kanban View.`);
                    }
                }
                if (column.uidt === _nocodbsdk.UITypes.MultiSelect && colBody.uidt === _nocodbsdk.UITypes.SingleSelect) {
                    // MultiSelect to SingleSelect
                    if (driverType === 'mysql' || driverType === 'mysql2') {
                        await sqlClient.raw(`UPDATE ?? SET ?? = SUBSTRING_INDEX(??, ',', 1) WHERE ?? LIKE '%,%';`, [
                            baseModel.getTnPath(table.table_name),
                            column.column_name,
                            column.column_name,
                            column.column_name
                        ]);
                    } else if (driverType === 'pg') {
                        await sqlClient.raw(`UPDATE ?? SET ?? = split_part(??, ',', 1);`, [
                            baseModel.getTnPath(table.table_name),
                            column.column_name,
                            column.column_name
                        ]);
                    } else if (driverType === 'sqlite3') {
                        await sqlClient.raw(`UPDATE ?? SET ?? = substr(??, 1, instr(??, ',') - 1) WHERE ?? LIKE '%,%';`, [
                            baseModel.getTnPath(table.table_name),
                            column.column_name,
                            column.column_name,
                            column.column_name,
                            column.column_name
                        ]);
                    }
                } else {
                    // Text to SingleSelect/MultiSelect
                    const dbDriver = await reuseOrSave('dbDriver', reuse, async ()=>_NcConnectionMgrv2.default.get(source));
                    const baseModel = await reuseOrSave('baseModel', reuse, async ()=>_models.Model.getBaseModelSQL(context, {
                            id: table.id,
                            dbDriver: dbDriver
                        }));
                    const data = await baseModel.execAndParse(baseModel.dbDriver.raw('SELECT DISTINCT ?? FROM ??', [
                        column.column_name,
                        baseModel.getTnPath(table.table_name)
                    ]).toQuery(), null, {
                        raw: true
                    });
                    if (data.length && column.uidt !== colBody.uidt) {
                        const existingOptions = colBody.colOptions.options.map((el)=>el.title);
                        const options = data.reduce((acc, el)=>{
                            if (el[column.column_name]) {
                                const values = String(el[column.column_name]).split(',');
                                if (values.length > 1) {
                                    if (colBody.uidt === _nocodbsdk.UITypes.SingleSelect) {
                                        _catchError.NcError.get(context).badRequest('SingleSelect cannot have comma separated values, please use MultiSelect instead.');
                                    }
                                }
                                for (const v of values){
                                    if (!existingOptions.includes(v.trim())) {
                                        acc.push({
                                            title: v.trim()
                                        });
                                        existingOptions.push(v.trim());
                                    }
                                }
                            }
                            return acc;
                        }, []);
                        colBody.colOptions.options = [
                            ...colBody.colOptions.options,
                            ...options
                        ];
                    }
                }
                // Handle migrations
                if ((_column_colOptions1 = column.colOptions) == null ? void 0 : _column_colOptions1.options) {
                    for (const op of column.colOptions.options.filter((el)=>el.order === null)){
                        op.title = op.title.replace(/^'/, '').replace(/'$/, '');
                    }
                }
                // Handle default values
                const optionTitles = colBody.colOptions.options.map((el)=>el.title.replace(/'/g, "''"));
                if (colBody.cdf) {
                    if (colBody.uidt === _nocodbsdk.UITypes.SingleSelect) {
                        try {
                            if (!optionTitles.includes(colBody.cdf.replace(/'/g, "''"))) {
                                _catchError.NcError.get(context).badRequest(`Default value '${colBody.cdf}' is not a select option.`);
                            }
                        } catch (e) {
                            colBody.cdf = colBody.cdf.replace(/^'/, '').replace(/'$/, '');
                            if (!optionTitles.includes(colBody.cdf.replace(/'/g, "''"))) {
                                _catchError.NcError.get(context).badRequest(`Default value '${colBody.cdf}' is not a select option.`);
                            }
                        }
                    } else {
                        try {
                            for (const cdf of colBody.cdf.split(',')){
                                if (!optionTitles.includes(cdf.replace(/'/g, "''"))) {
                                    _catchError.NcError.get(context).badRequest(`Default value '${cdf}' is not a select option.`);
                                }
                            }
                        } catch (e) {
                            colBody.cdf = colBody.cdf.replace(/^'/, '').replace(/'$/, '');
                            for (const cdf of colBody.cdf.split(',')){
                                if (!optionTitles.includes(cdf.replace(/'/g, "''"))) {
                                    _catchError.NcError.get(context).badRequest(`Default value '${cdf}' is not a select option.`);
                                }
                            }
                        }
                    }
                    // handle single quote for default value
                    if (driverType === 'pg' || driverType === 'sqlite3') {
                        colBody.cdf = colBody.cdf.replace(/'/g, "'");
                    } else {
                        colBody.cdf = colBody.cdf.replace(/'/g, "''");
                    }
                    if (driverType === 'pg') {
                        colBody.cdf = `'${colBody.cdf}'`;
                    }
                }
                // Restrict duplicates
                const titles = colBody.colOptions.options.map((el)=>el.title);
                if (titles.some(function(item) {
                    return titles.indexOf(item) !== titles.lastIndexOf(item);
                })) {
                    _catchError.NcError.get(context).badRequest('Duplicates are not allowed!');
                }
                // Restrict empty options
                if (titles.some(function(item) {
                    return item === '';
                })) {
                    _catchError.NcError.get(context).badRequest('Empty options are not allowed!');
                }
                // Trim end of enum/set
                if (colBody.dt === 'enum' || colBody.dt === 'set') {
                    for (const opt of colBody.colOptions.options){
                        opt.title = opt.title.trimEnd();
                    }
                }
                if (colBody.uidt === _nocodbsdk.UITypes.SingleSelect) {
                    var _colBody_colOptions4;
                    colBody.dtxp = ((_colBody_colOptions4 = colBody.colOptions) == null ? void 0 : _colBody_colOptions4.options.length) ? `${colBody.colOptions.options.map((o)=>`'${o.title.replace(/'/gi, "''")}'`).join(',')}` : '';
                } else if (colBody.uidt === _nocodbsdk.UITypes.MultiSelect) {
                    var _colBody_colOptions5;
                    colBody.dtxp = ((_colBody_colOptions5 = colBody.colOptions) == null ? void 0 : _colBody_colOptions5.options.length) ? `${colBody.colOptions.options.map((o)=>{
                        if (o.title.includes(',')) {
                            _catchError.NcError.get(context).badRequest("Illegal char(',') for MultiSelect");
                        }
                        return `'${o.title.replace(/'/gi, "''")}'`;
                    }).join(',')}` : '';
                }
                // Handle empty enum/set for mysql (we restrict empty user options beforehand)
                if (driverType === 'mysql' || driverType === 'mysql2') {
                    if (!colBody.colOptions.options.length && (!colBody.dtxp || colBody.dtxp === '')) {
                        colBody.dtxp = "''";
                    }
                    if (colBody.dt === 'set') {
                        var _colBody_colOptions6;
                        if (((_colBody_colOptions6 = colBody.colOptions) == null ? void 0 : _colBody_colOptions6.options.length) > 64) {
                            colBody.dt = 'text';
                        }
                    }
                }
                // normalize multiselect values (split + trim + join) when converting to MultiSelect
                if (column.uidt !== colBody.uidt && colBody.uidt === _nocodbsdk.UITypes.MultiSelect) {
                    if (driverType === 'pg') {
                        await sqlClient.raw(`
              UPDATE :table_name:
              SET :column_name: = regexp_replace(
                regexp_replace(:column_name:, '\\s*,\\s*', ',', 'g'),
                '^,|,$',
                '',
                'g'
              )
              WHERE :column_name: IS NOT NULL
              `, {
                            table_name: baseModel.getTnPath(table.table_name),
                            column_name: column.column_name
                        });
                    } else if (driverType === 'mysql' || driverType === 'mysql2') {
                        await sqlClient.raw(`
              UPDATE :table_name:
              SET :column_name: = TRIM(BOTH ',' FROM
                REGEXP_REPLACE(
                  :column_name:,
                  '\\\\s*,\\\\s*',
                  ','
                )
              )
              WHERE :column_name: IS NOT NULL
              `, {
                            table_name: baseModel.getTnPath(table.table_name),
                            column_name: column.column_name
                        });
                    } else if (driverType === 'sqlite3') {
                        await sqlClient.raw(`
              UPDATE :table_name:
              SET :column_name: = TRIM(
                REPLACE(
                  REPLACE(
                    REPLACE(
                      ',' || :column_name: || ',',
                      ', ',
                      ','
                    ),
                    ' ,',
                    ','
                  ),
                  ',,',
                  ','
                ),
                ','
              )
              WHERE :column_name: IS NOT NULL
              `, {
                            table_name: baseModel.getTnPath(table.table_name),
                            column_name: column.column_name
                        });
                    }
                }
                // Handle option delete
                if ((_column_colOptions2 = column.colOptions) == null ? void 0 : _column_colOptions2.options) {
                    for (const option of column.colOptions.options.filter((oldOp)=>!colBody.colOptions.options.find((newOp)=>newOp.id === oldOp.id || newOp.title === oldOp.title))){
                        if (!supportedDrivers.includes(driverType) && column.uidt === _nocodbsdk.UITypes.MultiSelect) {
                            _catchError.NcError.get(context).badRequest('Your database not yet supported for this operation. Please remove option from records manually before dropping.');
                        }
                        if (column.uidt === _nocodbsdk.UITypes.SingleSelect) {
                            await baseModel.bulkUpdateAll({
                                where: `(${column.title},eq,${option.title})`,
                                skipValidationAndHooks: true
                            }, {
                                [column.column_name]: null
                            }, {
                                cookie: req
                            });
                        } else if (column.uidt === _nocodbsdk.UITypes.MultiSelect) {
                            if (driverType === 'mysql' || driverType === 'mysql2') {
                                if (colBody.dt === 'set') {
                                    await sqlClient.raw(`UPDATE ?? SET ?? = TRIM(BOTH ',' FROM REPLACE(CONCAT(',', ??, ','), CONCAT(',', ?, ','), ',')) WHERE FIND_IN_SET(?, ??)`, [
                                        baseModel.getTnPath(table.table_name),
                                        column.column_name,
                                        column.column_name,
                                        option.title,
                                        option.title,
                                        column.column_name
                                    ]);
                                } else {
                                    await sqlClient.raw(`UPDATE ?? SET ?? = TRIM(BOTH ',' FROM REPLACE(CONCAT(',', ??, ','), CONCAT(',', ?, ','), ','))`, [
                                        baseModel.getTnPath(table.table_name),
                                        column.column_name,
                                        column.column_name,
                                        option.title
                                    ]);
                                }
                            } else if (driverType === 'pg') {
                                await sqlClient.raw(`UPDATE ?? SET ??  = array_to_string(array_remove(string_to_array(??, ','), ?), ',')`, [
                                    baseModel.getTnPath(table.table_name),
                                    column.column_name,
                                    column.column_name,
                                    option.title
                                ]);
                            } else if (driverType === 'sqlite3') {
                                await sqlClient.raw(`UPDATE ?? SET ?? = TRIM(REPLACE(',' || ?? || ',', ',' || ? || ',', ','), ',')`, [
                                    baseModel.getTnPath(table.table_name),
                                    column.column_name,
                                    column.column_name,
                                    option.title
                                ]);
                            }
                        }
                    }
                }
                /*
          Interchange is used to handle cyclic replacements without conflicts (e.g., A → B, B → C, C → A):
          1. We replace conflicting new options with temporary unique titles (e.g., A → A_1, B → B_1, C → C_1)
          2. We update the database with these temporary unique titles
          3. Finally, we replace the temporary unique titles with the intended new option titles
        */ const interchange = [];
                const titleChanges = []; // Title change keeps direct map of old title to new title
                // Handle option update
                if ((_column_colOptions3 = column.colOptions) == null ? void 0 : _column_colOptions3.options) {
                    const old_titles = column.colOptions.options.map((el)=>el.title);
                    for (const option of column.colOptions.options.filter((oldOp)=>colBody.colOptions.options.find((newOp)=>newOp.id === oldOp.id && newOp.title !== oldOp.title))){
                        if (!supportedDrivers.includes(driverType) && column.uidt === _nocodbsdk.UITypes.MultiSelect) {
                            _catchError.NcError.get(context).badRequest('Your database not yet supported for this operation. Please remove option from records manually before updating.');
                        }
                        const newOp = _extends({}, colBody.colOptions.options.find((el)=>option.id === el.id));
                        titleChanges.push({
                            old_title: option.title,
                            new_title: newOp.title
                        });
                        // Handle title conflicts by creating unique temporary titles
                        if (old_titles.includes(newOp.title)) {
                            const def_option = _extends({}, newOp);
                            let title_counter = 1;
                            while(old_titles.includes(newOp.title)){
                                newOp.title = `${def_option.title}_${title_counter++}`;
                            }
                            // Store the temporary title mapping
                            interchange.push({
                                def_option,
                                temp_title: newOp.title
                            });
                        }
                        // Append new option before editing
                        if ((driverType === 'mysql' || driverType === 'mysql2') && (column.dt === 'enum' || column.dt === 'set')) {
                            column.colOptions.options.push({
                                title: newOp.title
                            });
                            let temp_dtxp = '';
                            if (column.uidt === _nocodbsdk.UITypes.SingleSelect) {
                                temp_dtxp = column.colOptions.options.length ? `${column.colOptions.options.map((o)=>`'${o.title.replace(/'/gi, "''")}'`).join(',')}` : '';
                            } else if (column.uidt === _nocodbsdk.UITypes.MultiSelect) {
                                temp_dtxp = column.colOptions.options.length ? `${column.colOptions.options.map((o)=>{
                                    if (o.title.includes(',')) {
                                        _catchError.NcError.get(context).badRequest("Illegal char(',') for MultiSelect");
                                    }
                                    return `'${o.title.replace(/'/gi, "''")}'`;
                                }).join(',')}` : '';
                            }
                            column.dtxp = temp_dtxp;
                            await this.updateMetaAndDatabase(context, {
                                table,
                                column,
                                source,
                                reuse
                            });
                        }
                        if (column.uidt === _nocodbsdk.UITypes.SingleSelect) {
                            await baseModel.bulkUpdateAll({
                                where: `(${column.title},eq,${option.title})`,
                                skipValidationAndHooks: true
                            }, {
                                [column.column_name]: newOp.title
                            }, {
                                cookie: req
                            });
                        } else if (column.uidt === _nocodbsdk.UITypes.MultiSelect) {
                            if (driverType === 'mysql' || driverType === 'mysql2') {
                                if (colBody.dt === 'set') {
                                    await sqlClient.raw(`UPDATE ?? SET ?? = TRIM(BOTH ',' FROM REPLACE(CONCAT(',', ??, ','), CONCAT(',', ?, ','), CONCAT(',', ?, ','))) WHERE FIND_IN_SET(?, ??)`, [
                                        baseModel.getTnPath(table.table_name),
                                        column.column_name,
                                        column.column_name,
                                        option.title,
                                        newOp.title,
                                        option.title,
                                        column.column_name
                                    ]);
                                } else {
                                    await sqlClient.raw(`UPDATE ?? SET ?? = TRIM(BOTH ',' FROM REPLACE(CONCAT(',', ??, ','), CONCAT(',', ?, ','), CONCAT(',', ?, ',')))`, [
                                        baseModel.getTnPath(table.table_name),
                                        column.column_name,
                                        column.column_name,
                                        option.title,
                                        newOp.title
                                    ]);
                                }
                            } else if (driverType === 'pg') {
                                await sqlClient.raw(`UPDATE ?? SET ??  = array_to_string(array_replace(string_to_array(??, ','), ?, ?), ',')`, [
                                    baseModel.getTnPath(table.table_name),
                                    column.column_name,
                                    column.column_name,
                                    option.title,
                                    newOp.title
                                ]);
                            } else if (driverType === 'sqlite3') {
                                await sqlClient.raw(`UPDATE ?? SET ?? = TRIM(REPLACE(',' || ?? || ',', ',' || ? || ',', ',' || ? || ','), ',')`, [
                                    baseModel.getTnPath(table.table_name),
                                    column.column_name,
                                    column.column_name,
                                    option.title,
                                    newOp.title
                                ]);
                            }
                        }
                    }
                }
                // Process temporary title interchanges (conflict resolution)
                for (const ch of interchange){
                    const newOp = ch.def_option;
                    if (column.uidt === _nocodbsdk.UITypes.SingleSelect) {
                        await baseModel.bulkUpdateAll({
                            where: `(${column.title},eq,${ch.temp_title})`,
                            skipValidationAndHooks: true
                        }, {
                            [column.column_name]: newOp.title
                        }, {
                            cookie: req
                        });
                    } else if (column.uidt === _nocodbsdk.UITypes.MultiSelect) {
                        if (driverType === 'mysql' || driverType === 'mysql2') {
                            if (colBody.dt === 'set') {
                                await sqlClient.raw(`UPDATE ?? SET ?? = TRIM(BOTH ',' FROM REPLACE(CONCAT(',', ??, ','), CONCAT(',', ?, ','), CONCAT(',', ?, ','))) WHERE FIND_IN_SET(?, ??)`, [
                                    baseModel.getTnPath(table.table_name),
                                    column.column_name,
                                    column.column_name,
                                    ch.temp_title,
                                    newOp.title,
                                    ch.temp_title,
                                    column.column_name
                                ]);
                            } else {
                                await sqlClient.raw(`UPDATE ?? SET ?? = TRIM(BOTH ',' FROM REPLACE(CONCAT(',', ??, ','), CONCAT(',', ?, ','), CONCAT(',', ?, ',')))`, [
                                    baseModel.getTnPath(table.table_name),
                                    column.column_name,
                                    column.column_name,
                                    ch.temp_title,
                                    newOp.title,
                                    ch.temp_title,
                                    column.column_name
                                ]);
                            }
                        } else if (driverType === 'pg') {
                            await sqlClient.raw(`UPDATE ?? SET ??  = array_to_string(array_replace(string_to_array(??, ','), ?, ?), ',')`, [
                                baseModel.getTnPath(table.table_name),
                                column.column_name,
                                column.column_name,
                                ch.temp_title,
                                newOp.title
                            ]);
                        } else if (driverType === 'sqlite3') {
                            await sqlClient.raw(`UPDATE ?? SET ?? = TRIM(REPLACE(',' || ?? || ',', ',' || ? || ',', ',' || ? || ','), ',')`, [
                                baseModel.getTnPath(table.table_name),
                                column.column_name,
                                column.column_name,
                                ch.temp_title,
                                newOp.title
                            ]);
                        }
                    }
                }
                // handle trim value when converting it from SingleLineText cell to SingleSelect
                if (column.uidt === _nocodbsdk.UITypes.SingleLineText && colBody.uidt === _nocodbsdk.UITypes.SingleSelect) {
                    await sqlClient.raw(`UPDATE ??
               SET ?? = TRIM(??)
               WHERE ?? <> TRIM(??)`, [
                        baseModel.getTnPath(table.table_name),
                        column.column_name,
                        column.column_name,
                        column.column_name,
                        column.column_name
                    ]);
                }
                // Update value in filters that reference this column
                const filters = await _models.Filter.getFiltersByColumn(context, column.id);
                for (const filter of filters != null ? filters : []){
                    var _filter_value;
                    let newValue = filter.value;
                    // do not try to map when the comparison has no value
                    if ((0, _nocodbsdk.ncIsUndefined)(newValue) || (0, _nocodbsdk.ncIsNull)(newValue) || newValue === '') {
                        continue;
                    }
                    // Split filter values and update them based on title changes
                    const values = (_filter_value = filter.value) == null ? void 0 : _filter_value.split(',');
                    const updatedValues = values.map((val)=>{
                        const change = titleChanges.find((c)=>c.old_title === val.trim());
                        return change ? change.new_title : val;
                    });
                    newValue = updatedValues.join(',');
                    // Update filter if value changed
                    if (newValue !== filter.value) {
                        await _models.Filter.update(context, filter.id, {
                            value: newValue
                        });
                    }
                }
            }
            await this.updateMetaAndDatabase(context, {
                table,
                // include id since it won't be part of api request
                column: _extends({}, colBody, {
                    id: column.id
                }),
                source,
                reuse,
                processColumn: async ()=>{
                    await this.updateFormulas(context, {
                        oldColumn: column,
                        colBody
                    });
                }
            });
            if (column.uidt === _nocodbsdk.UITypes.SingleSelect) {
                const kanbanViewsByColId = await _models.KanbanView.getViewsByGroupingColId(context, column.id) || [];
                for (const kanbanView of kanbanViewsByColId){
                    const view = await _models.View.get(context, kanbanView.fk_view_id);
                    view.meta = (0, _modelUtils.parseMetaProp)(view);
                    if (colBody.uidt === _nocodbsdk.UITypes.SingleSelect) {
                        var _colBody_colOptions7;
                        // Column is/remains SingleSelect - update the kanban view
                        await _models.View.update(context, view.id, _extends({}, view, {
                            meta: _extends({}, view.meta, {
                                groupingFieldColumn: colBody
                            })
                        }));
                        // Update kanban stack meta when column options are modified
                        if ((_colBody_colOptions7 = colBody.colOptions) == null ? void 0 : _colBody_colOptions7.options) {
                            const stackMetaObj = (0, _nocodbsdk.parseProp)(kanbanView.meta) || {};
                            if (!stackMetaObj[column.id]) {
                                stackMetaObj[column.id] = [];
                            }
                            // Build new stack meta based on updated column options
                            const newStackMeta = [];
                            const existingStacks = stackMetaObj[column.id] || [];
                            // Add uncategorized stack first
                            const existingUncategorized = existingStacks.find((stack)=>stack.id === 'uncategorized');
                            const uncategorizedStack = existingUncategorized || {
                                id: 'uncategorized',
                                title: null,
                                order: 0,
                                color: '#6A7184',
                                collapsed: false
                            };
                            newStackMeta.push(uncategorizedStack);
                            // Process each column option, preserving existing order when possible
                            for (const option of colBody.colOptions.options){
                                const existingStack = existingStacks.find((stack)=>stack.id === option.id);
                                if (existingStack) {
                                    newStackMeta.push(_extends({}, option, {
                                        order: existingStack.order,
                                        collapsed: existingStack.collapsed || false
                                    }));
                                } else {
                                    const maxOrder = Math.max(...existingStacks.map((s)=>s.order || 0), 0);
                                    newStackMeta.push(_extends({}, option, {
                                        order: maxOrder + 1,
                                        collapsed: false
                                    }));
                                }
                            }
                            // Sort by order
                            newStackMeta.sort((a, b)=>(a.order || 0) - (b.order || 0));
                            // Update kanban view meta
                            stackMetaObj[column.id] = newStackMeta;
                            await _models.KanbanView.update(context, kanbanView.fk_view_id, {
                                meta: stackMetaObj
                            });
                        }
                    } else {
                        // Column is no longer SingleSelect - remove grouping
                        await _models.View.update(context, view.id, _extends({}, view, {
                            meta: _extends({}, view.meta, {
                                groupingFieldColumn: null
                            })
                        }));
                        // Clear the kanban stack meta for this column
                        const stackMetaObj = (0, _nocodbsdk.parseProp)(kanbanView.meta) || {};
                        delete stackMetaObj[column.id];
                        await _models.KanbanView.update(context, kanbanView.fk_view_id, {
                            meta: stackMetaObj
                        });
                    }
                    await view.getView(context);
                    _NocoSocket.default.broadcastEvent(context, {
                        event: _nocodbsdk.EventType.META_EVENT,
                        payload: {
                            action: 'view_update',
                            payload: view
                        }
                    }, context.socket_id);
                }
            }
        } else if (colBody.uidt === _nocodbsdk.UITypes.User) {
            if (isSyncedColumn) {
                _catchError.NcError.get(context).invalidRequestBody(`The column '${column.title || column.column_name}' is a synced column and cannot be updated.`);
            }
            // handle default value for user column
            if (typeof colBody.cdf !== 'string') {
                colBody.cdf = '';
            } else if (colBody.cdf) {
                const baseUsers = await _models.BaseUser.getUsersList(context, {
                    base_id: source.base_id,
                    include_ws_deleted: false
                });
                const emailOrIds = colBody.cdf.split(',');
                const emailsNotPresent = emailOrIds.filter((el)=>{
                    return !baseUsers.find((user)=>user.id === el || user.email === el);
                });
                if (emailsNotPresent.length) {
                    _catchError.NcError.get(context).badRequest(`The following default users are not part of workspace: ${emailsNotPresent.join(', ')}`);
                }
                const ids = emailOrIds.map((el)=>{
                    const user = baseUsers.find((user)=>user.id === el || user.email === el);
                    return user.id;
                });
                colBody.cdf = ids.join(',');
            }
            if (column.uidt === _nocodbsdk.UITypes.User) {
                var _colBody_meta, _column_meta2;
                // multi user to single user
                if (isSyncedColumn) {
                    _catchError.NcError.get(context).invalidRequestBody(`The column '${column.title || column.column_name}' is a synced column and cannot be updated.`);
                }
                if (((_colBody_meta = colBody.meta) == null ? void 0 : _colBody_meta.is_multi) === false && ((_column_meta2 = column.meta) == null ? void 0 : _column_meta2.is_multi) === true) {
                    const baseModel = await reuseOrSave('baseModel', reuse, async ()=>_models.Model.getBaseModelSQL(context, {
                            id: table.id,
                            dbDriver: await reuseOrSave('dbDriver', reuse, async ()=>_NcConnectionMgrv2.default.get(source))
                        }));
                    const dbDriver = await reuseOrSave('dbDriver', reuse, async ()=>_NcConnectionMgrv2.default.get(source));
                    const driverType = dbDriver.clientType();
                    // MultiSelect to SingleSelect
                    if (driverType === 'mysql' || driverType === 'mysql2') {
                        await sqlClient.raw(`UPDATE ?? SET ?? = SUBSTRING_INDEX(??, ',', 1) WHERE ?? LIKE '%,%';`, [
                            baseModel.getTnPath(table.table_name),
                            column.column_name,
                            column.column_name,
                            column.column_name
                        ]);
                    } else if (driverType === 'pg') {
                        await sqlClient.raw(`UPDATE ?? SET ?? = split_part(??, ',', 1);`, [
                            baseModel.getTnPath(table.table_name),
                            column.column_name,
                            column.column_name
                        ]);
                    } else if (driverType === 'sqlite3') {
                        await sqlClient.raw(`UPDATE ?? SET ?? = substr(??, 1, instr(??, ',') - 1) WHERE ?? LIKE '%,%';`, [
                            baseModel.getTnPath(table.table_name),
                            column.column_name,
                            column.column_name,
                            column.column_name,
                            column.column_name
                        ]);
                    }
                }
                colBody = await (0, _getColumnPropsFromUIDT.default)(colBody, source);
                await this.updateMetaAndDatabase(context, {
                    table,
                    // pass id since it won't be part of api request
                    column: _extends({}, colBody, {
                        id: column.id
                    }),
                    source,
                    reuse,
                    processColumn: async ()=>{
                        await this.updateFormulas(context, {
                            oldColumn: column,
                            colBody
                        });
                    }
                });
            } else {
                if (isSyncedColumn) {
                    _catchError.NcError.get(context).invalidRequestBody(`The column '${column.title || column.column_name}' is a synced column and cannot be updated.`);
                }
                // email/text to user
                const baseModel = await reuseOrSave('baseModel', reuse, async ()=>_models.Model.getBaseModelSQL(context, {
                        id: table.id,
                        dbDriver: await reuseOrSave('dbDriver', reuse, async ()=>_NcConnectionMgrv2.default.get(source))
                    }));
                const baseUsers = await _models.BaseUser.getUsersList(context, {
                    base_id: column.base_id
                });
                const data = await baseModel.execAndParse(sqlClient.knex.raw('SELECT DISTINCT ?? FROM ??', [
                    column.column_name,
                    baseModel.getTnPath(table.table_name)
                ]).toQuery());
                const rows = data.map((el)=>el[column.column_name]);
                if (rows.some((el)=>(el == null ? void 0 : el.split(',').length) > 1)) {
                    colBody.meta = {
                        is_multi: true
                    };
                }
                // create nested replace statement for each user
                let setStatement = 'null';
                if ([
                    _nocodbsdk.UITypes.URL,
                    _nocodbsdk.UITypes.Email,
                    _nocodbsdk.UITypes.SingleLineText,
                    _nocodbsdk.UITypes.PhoneNumber,
                    _nocodbsdk.UITypes.SingleLineText,
                    _nocodbsdk.UITypes.LongText,
                    _nocodbsdk.UITypes.MultiSelect
                ].includes(column.uidt)) {
                    const dbDriver = await reuseOrSave('dbDriver', reuse, async ()=>_NcConnectionMgrv2.default.get(source));
                    const driverType = dbDriver.clientType();
                    let trimColumn = `??`;
                    if (driverType === 'mysql' || driverType === 'mysql2') {
                        trimColumn = `TRIM(BOTH ' ' FROM ??)`;
                    } else if (driverType === 'pg') {
                        trimColumn = `BTRIM(??)`;
                    } else if (driverType === 'sqlite3') {
                        trimColumn = `TRIM(??)`;
                    }
                    setStatement = baseUsers.map((user)=>sqlClient.knex.raw(`WHEN ${trimColumn} = ? THEN ?`, [
                            column.column_name,
                            user.email,
                            user.id
                        ]).toQuery()).join('\n');
                    setStatement = `CASE\n${setStatement}\nELSE null\nEND`;
                }
                await sqlClient.raw(`UPDATE ?? SET ?? = ${setStatement};`, [
                    baseModel.getTnPath(table.table_name),
                    column.column_name
                ]);
                colBody = await (0, _getColumnPropsFromUIDT.default)(colBody, source);
                await this.updateMetaAndDatabase(context, {
                    table,
                    // pass id since it won't be part of api request
                    column: _extends({}, colBody, {
                        id: column.id
                    }),
                    source,
                    reuse,
                    processColumn: async ()=>{
                        await this.updateFormulas(context, {
                            oldColumn: column,
                            colBody
                        });
                    }
                });
            }
        } else {
            var _colBody_meta1;
            if (isSyncedColumn) {
                _catchError.NcError.get(context).invalidRequestBody(`The column '${column.title || column.column_name}' is a synced column and cannot be updated.`);
            }
            if (column.uidt === _nocodbsdk.UITypes.User) {
                const baseModel = await reuseOrSave('baseModel', reuse, async ()=>_models.Model.getBaseModelSQL(context, {
                        id: table.id,
                        dbDriver: await reuseOrSave('dbDriver', reuse, async ()=>_NcConnectionMgrv2.default.get(source))
                    }));
                const baseUsers = await _models.BaseUser.getUsersList(context, {
                    base_id: column.base_id
                });
                // create nested replace statement for each user
                const setStatement = baseUsers.reduce((acc, user)=>{
                    const qb = sqlClient.knex.raw(`REPLACE(${acc}, ?, ?)`, [
                        user.id,
                        user.email
                    ]);
                    return qb.toQuery();
                }, sqlClient.knex.raw(`??`, [
                    column.column_name
                ]).toQuery());
                await sqlClient.raw(`UPDATE ?? SET ?? = ${setStatement};`, [
                    baseModel.getTnPath(table.table_name),
                    column.column_name
                ]);
            } else if (column.uidt === _nocodbsdk.UITypes.SingleSelect && column.uidt !== colBody.uidt && (await _models.KanbanView.getViewsByGroupingColId(context, column.id)).length > 0) {
                _catchError.NcError.get(context).badRequest(`The column '${column.title}' is being used in Kanban View. Please update stack by field or delete Kanban View first.`);
            }
            if ((0, _nocodbsdk.isAIPromptCol)(column) && (colBody.uidt !== _nocodbsdk.UITypes.LongText || colBody.uidt === _nocodbsdk.UITypes.LongText && ((_colBody_meta1 = colBody.meta) == null ? void 0 : _colBody_meta1[_nocodbsdk.LongTextAiMetaProp]) !== true)) {
                const baseModel = await reuseOrSave('baseModel', reuse, async ()=>_models.Model.getBaseModelSQL(context, {
                        id: table.id,
                        dbDriver: await reuseOrSave('dbDriver', reuse, async ()=>_NcConnectionMgrv2.default.get(source))
                    }));
                await (0, _dataConversion.convertAIRecordTypeToValue)({
                    source,
                    table,
                    column,
                    baseModel,
                    sqlClient
                });
            } else if ((0, _nocodbsdk.isAIPromptCol)(colBody)) {
                var _column_meta3;
                let prompt = '';
                /*
          Substitute column alias with id in prompt
        */ if (colBody.prompt_raw) {
                    await table.getColumns(context);
                    prompt = colBody.prompt_raw.replace(/{(.*?)}/g, (match, p1)=>{
                        const column = table.columns.find((c)=>c.title === p1);
                        if (!column) {
                            _catchError.NcError.get(context).badRequest(`Field '${p1}' not found`);
                        }
                        return `{${column.id}}`;
                    });
                }
                colBody.prompt = prompt;
                // If column wasn't AI before, convert the data to AIRecordType format
                if (column.uidt !== _nocodbsdk.UITypes.LongText || ((_column_meta3 = column.meta) == null ? void 0 : _column_meta3[_nocodbsdk.LongTextAiMetaProp]) !== true) {
                    const baseModel = await reuseOrSave('baseModel', reuse, async ()=>_models.Model.getBaseModelSQL(context, {
                            id: table.id,
                            dbDriver: await reuseOrSave('dbDriver', reuse, async ()=>_NcConnectionMgrv2.default.get(source))
                        }));
                    await (0, _dataConversion.convertValueToAIRecordType)({
                        source,
                        table,
                        column,
                        baseModel,
                        sqlClient,
                        user: param.user
                    });
                }
            }
            const originalCdf = colBody.cdf;
            colBody = await (0, _getColumnPropsFromUIDT.default)(colBody, source);
            if (typeof colBody.cdf !== 'undefined' && typeof originalCdf === 'undefined') {
                // do not override cdf when request is undefined
                colBody.cdf = originalCdf;
            }
            await this.updateMetaAndDatabase(context, {
                table,
                // pass id since it won't be part of api request
                column: _extends({}, colBody, {
                    id: column.id
                }),
                source,
                reuse,
                processColumn: async ()=>{
                    await this.updateFormulas(context, {
                        oldColumn: column,
                        colBody
                    });
                }
            });
        }
        const DATE_TIME_TYPES = [
            _nocodbsdk.UITypes.Date,
            _nocodbsdk.UITypes.DateTime,
            _nocodbsdk.UITypes.CreatedTime,
            _nocodbsdk.UITypes.LastModifiedTime
        ];
        if (DATE_TIME_TYPES.includes(column.uidt) && !DATE_TIME_TYPES.includes(colBody.uidt)) {
            // Column type changed from date/time to non-date/time - delete all ranges
            const calendarRanges = await _models.CalendarRange.IsColumnBeingUsedAsRange(context, column.id);
            for (const col of calendarRanges != null ? calendarRanges : []){
                await _models.CalendarRange.delete(col.id, context);
            }
        } else if (DATE_TIME_TYPES.includes(colBody.uidt)) {
            // Column is still/becoming a date/time type - validate ranges
            const calendarRanges = await _models.CalendarRange.IsColumnBeingUsedAsRange(context, column.id);
            for (const range of calendarRanges != null ? calendarRanges : []){
                let shouldDeleteRange = false;
                if (range.fk_from_column_id === column.id && range.fk_to_column_id) {
                    const endColumn = await _models.Column.get(context, {
                        colId: range.fk_to_column_id
                    });
                    if (!endColumn || endColumn.uidt !== colBody.uidt) {
                        shouldDeleteRange = true;
                    } else {
                        var _colBody_meta2, _endColumn_meta;
                        // Check timezone compatibility
                        const newTimezone = (_colBody_meta2 = colBody.meta) == null ? void 0 : _colBody_meta2.timezone;
                        const endTimezone = (_endColumn_meta = endColumn.meta) == null ? void 0 : _endColumn_meta.timezone;
                        // Delete if both have timezones but they don't match
                        if (newTimezone && endTimezone && newTimezone !== endTimezone) {
                            shouldDeleteRange = true;
                        }
                    }
                } else if (range.fk_to_column_id === column.id && range.fk_from_column_id) {
                    const startColumn = await _models.Column.get(context, {
                        colId: range.fk_from_column_id
                    });
                    if (!startColumn || startColumn.uidt !== colBody.uidt) {
                        shouldDeleteRange = true;
                    } else {
                        var _colBody_meta3, _startColumn_meta;
                        // Check timezone compatibility
                        const newTimezone = (_colBody_meta3 = colBody.meta) == null ? void 0 : _colBody_meta3.timezone;
                        const startTimezone = (_startColumn_meta = startColumn.meta) == null ? void 0 : _startColumn_meta.timezone;
                        // Delete if both have timezones but they don't match
                        if (newTimezone && startTimezone && newTimezone !== startTimezone) {
                            shouldDeleteRange = true;
                        }
                    }
                }
                if (shouldDeleteRange) {
                    await _models.CalendarRange.delete(range.id, context);
                }
            }
        }
        if (column.uidt === _nocodbsdk.UITypes.Attachment && colBody.uidt !== _nocodbsdk.UITypes.Attachment) {
            await _models.View.updateIfColumnUsedAsExpandedMode(context, column.id, column.fk_model_id);
        }
        const defaultView = await _models.View.getFirstCollaborativeView(context, column.fk_model_id, ncMeta);
        // Get all the columns in the table and return
        await table.getColumns(context, undefined, defaultView == null ? void 0 : defaultView.id);
        // Handle filter transformation if this is a column type change
        if (column.uidt !== colBody.uidt) {
            try {
                await this.filtersService.transformFiltersForColumnTypeChange(context, {
                    columnId: column.id,
                    newColumnType: colBody.uidt,
                    oldColumnType: column.uidt,
                    sqlUi
                });
            } catch (error) {
                // Log error but don't fail the column update
                this.logger.error('Failed to transform filters for column type change:', error.message);
            }
        }
        const updatedColumn = await _models.Column.get(context, {
            colId: param.columnId
        });
        this.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_UPDATE, {
            table,
            oldColumn,
            column: updatedColumn,
            columnId: param.columnId,
            req: param.req,
            context,
            columns: table.columns
        });
        await this.metaDependencyEventHandler.handleEvent(context, {
            eventType: _nocodbsdk.MetaEventType.COLUMN_UPDATED,
            oldEntity: oldColumn,
            newEntity: updatedColumn
        }, ncMeta);
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'column_update',
                payload: {
                    table,
                    column: updatedColumn
                }
            }
        }, context.socket_id);
        await applyRowColorInvolvement();
        if (!param.columnWebhookManager) {
            await columnWebhookManager.populateNewColumns();
            columnWebhookManager.emit();
        }
        if (param.apiVersion === _nocodbsdk.NcApiVersion.V3) {
            return column;
        }
        return table;
    }
    async columnGet(context, param) {
        return _models.Column.get(context, {
            colId: param.columnId
        });
    }
    async columnSetAsPrimary(context, param) {
        const oldColumn = await _models.Column.get(context, {
            colId: param.columnId
        });
        const oldPrimaryColumn = await _models.Model.get(context, oldColumn.fk_model_id).then((model)=>model.getColumns(context)).then((columns)=>columns.find((c)=>c.pv));
        if (!oldColumn) {
            _catchError.NcError.get(context).fieldNotFound(param.columnId);
        }
        const result = await _models.Model.updatePrimaryColumn(context, oldColumn.fk_model_id, oldColumn.id);
        const column = await _models.Column.get(context, {
            colId: param.columnId
        });
        // to reflect column properly on realtime and getWithInfo we will get default view column order and visibility in col meta
        const table = await _models.Model.getWithInfo(context, {
            id: column.fk_model_id
        });
        if (oldPrimaryColumn) {
            this.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_UPDATE, {
                table,
                oldColumn: oldPrimaryColumn,
                column: _extends({}, oldPrimaryColumn, {
                    pv: false
                }),
                columnId: column.id,
                req: param.req,
                context,
                columns: table.columns
            });
            _NocoSocket.default.broadcastEvent(context, {
                event: _nocodbsdk.EventType.META_EVENT,
                payload: {
                    action: 'column_update',
                    payload: {
                        table,
                        column: _extends({}, oldPrimaryColumn, {
                            pv: false
                        })
                    }
                }
            }, context.socket_id);
        }
        this.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_UPDATE, {
            table,
            oldColumn,
            column,
            columnId: column.id,
            req: param.req,
            context,
            columns: table.columns
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'column_update',
                payload: {
                    table,
                    column
                }
            }
        }, context.socket_id);
        return result;
    }
    async columnAdd(context, param, ncMeta = _Noco.default.ncMeta) {
        var _param_columnWebhookManager;
        let savedColumn;
        // if column_name is defined and title is not defined, set title to column_name
        if (param.column.column_name && !param.column.title) {
            param.column.title = param.column.column_name;
        }
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/ColumnReq', param.column, false, context);
        const reuse = param.reuse || {};
        const table = await reuseOrSave('table', reuse, async ()=>_models.Model.getWithInfo(context, {
                id: param.tableId
            }));
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        const source = await reuseOrSave('source', reuse, async ()=>_models.Source.get(context, table.source_id));
        // check if source is readonly and column type is not allowed
        if ((source == null ? void 0 : source.is_schema_readonly) && !_nocodbsdk.readonlyMetaAllowedTypes.includes(param.column.uidt)) {
            _catchError.NcError.get(context).sourceMetaReadOnly(source.alias);
        }
        if (param.column.system || [
            _nocodbsdk.UITypes.Order,
            _nocodbsdk.UITypes.ID
        ].includes(param.column.uidt)) {
            _catchError.NcError.get(context).invalidRequestBody(`Cannot manually create system columns`);
        } else {
            (0, _helpers.deleteColumnSystemPropsFromRequest)(param.column);
        }
        const base = await reuseOrSave('base', reuse, async ()=>source.getProject(context));
        const columnWebhookManager = (_param_columnWebhookManager = param.columnWebhookManager) != null ? _param_columnWebhookManager : (await new _columnwebhookmanager.ColumnWebhookManagerBuilder(context, ncMeta).withModelId(param.tableId)).forCreate();
        if (param.column.title || param.column.column_name) {
            const dbDriver = await reuseOrSave('dbDriver', reuse, async ()=>_NcConnectionMgrv2.default.get(source));
            const sqlClientType = dbDriver.clientType();
            const mxColumnLength = _models.Column.getMaxColumnNameLength(sqlClientType);
            if (!(0, _nocodbsdk.isVirtualCol)(param.column)) {
                param.column.column_name = (0, _helpers.sanitizeColumnName)(param.column.column_name || param.column.title, source.type);
            }
            // trim leading and trailing spaces from column title as knex trim them by default
            if (param.column.title) {
                param.column.title = param.column.title.trim();
            }
            // if column_name missing then generate it from title
            if (!param.column.column_name) {
                param.column.column_name = param.column.title;
            }
            if (param.column.column_name) {
                // - 5 is a buffer for suffix
                let colName = param.column.column_name.slice(0, mxColumnLength - 5);
                let suffix = 1;
                while(!await _models.Column.checkTitleAvailable(context, {
                    column_name: colName,
                    fk_model_id: param.tableId
                })){
                    colName = param.column.column_name.slice(0, mxColumnLength - 5);
                    colName += `_${suffix++}`;
                }
                param.column.column_name = colName;
            }
            if (param.column.column_name && param.column.column_name.length > mxColumnLength) {
                _catchError.NcError.get(context).invalidRequestBody(`Column name ${param.column.column_name} exceeds ${mxColumnLength} characters`);
            }
            if (param.column.title && param.column.title.length > 255) {
                _catchError.NcError.get(context).invalidRequestBody(`Column title ${param.column.title} exceeds 255 characters`);
            }
        }
        if (!(0, _nocodbsdk.isVirtualCol)(param.column) && !await _models.Column.checkTitleAvailable(context, {
            column_name: param.column.column_name,
            fk_model_id: param.tableId
        })) {
            _catchError.NcError.get(context).duplicateAlias({
                type: 'column',
                alias: param.column.column_name,
                label: 'name',
                base: context.base_id,
                additionalTrace: {
                    table: param.tableId
                }
            });
        }
        if (!await _models.Column.checkAliasAvailable(context, {
            title: param.column.title || param.column.column_name,
            fk_model_id: param.tableId
        })) {
            _catchError.NcError.get(context).duplicateAlias({
                type: 'column',
                alias: param.column.title,
                base: context.base_id,
                additionalTrace: {
                    table: param.tableId
                }
            });
        }
        let colBody = param.column;
        // Store original cdf before getColumnPropsFromUIDT potentially overwrites it
        const originalCdf = colBody.cdf;
        const originalUnique = colBody.unique;
        // Validate unique constraint BEFORE getColumnPropsFromUIDT
        if (colBody.unique) {
            (0, _uniqueConstraintHelpers.validateUniqueConstraint)(context, colBody.uidt, colBody.meta, colBody.unique, {
                is_meta: !!source.is_meta,
                is_local: !!source.is_local
            }, originalCdf);
        }
        // Check if default value is being set when unique constraint is enabled
        // Exclude UUID fields which are allowed to have both unique constraint and auto-generation
        if (originalCdf !== null && originalCdf !== undefined && originalCdf !== '' && colBody.unique && colBody.uidt !== _nocodbsdk.UITypes.UUID) {
            _catchError.NcError.get(context).badRequest('Default values are not allowed for unique fields. Please disable the unique constraint first.');
        }
        const colExtra = {
            view_id: colBody.view_id,
            column_order: colBody.column_order
        };
        switch(colBody.uidt){
            case _nocodbsdk.UITypes.Rollup:
                {
                    await (0, _helpers.validateRollupPayload)(context, param.column);
                    savedColumn = await _models.Column.insert(context, _extends({}, colBody, {
                        fk_model_id: table.id
                    }));
                }
                break;
            case _nocodbsdk.UITypes.Lookup:
                {
                    await (0, _helpers.validateLookupPayload)(context, param.column);
                    savedColumn = await _models.Column.insert(context, _extends({}, colBody, {
                        fk_model_id: table.id
                    }));
                }
                break;
            case _nocodbsdk.UITypes.Links:
            case _nocodbsdk.UITypes.LinkToAnotherRecord:
                savedColumn = await this.createLTARColumn(context, _extends({}, param, {
                    source,
                    base,
                    reuse,
                    colExtra,
                    columnWebhookManager
                }));
                this.appHooksService.emit(_nocodbsdk.AppEvents.RELATION_CREATE, {
                    column: _extends({}, colBody, {
                        fk_model_id: param.tableId,
                        base_id: base.id,
                        source_id: source.id
                    }),
                    req: param.req,
                    context
                });
                break;
            case _nocodbsdk.UITypes.QrCode:
                (0, _validateParams.default)([
                    'fk_qr_value_column_id'
                ], param.column, context);
                savedColumn = await _models.Column.insert(context, _extends({}, colBody, {
                    fk_model_id: table.id
                }));
                break;
            case _nocodbsdk.UITypes.Barcode:
                (0, _validateParams.default)([
                    'fk_barcode_value_column_id'
                ], param.column, context);
                savedColumn = await _models.Column.insert(context, _extends({}, colBody, {
                    fk_model_id: table.id
                }));
                break;
            case _nocodbsdk.UITypes.UUID:
                {
                    // UUID is only supported for PostgreSQL databases
                    if (source.type !== 'pg') {
                        _catchError.NcError.get(context).badRequest('UUID field type is supported only for PostgreSQL databases');
                    }
                    // Get column properties from UI type (sets dt='uuid', cdf='gen_random_uuid()')
                    colBody = await (0, _getColumnPropsFromUIDT.default)(colBody, source);
                    // UUID fields must have unique constraint (per PRD requirement DR-2)
                    colBody.unique = true;
                    // Generate column ID upfront for unique constraint name
                    const columnId = await ncMeta.genNanoid(_globals.MetaTable.COLUMNS);
                    colBody.base_id = context.base_id;
                    colBody.fk_model_id = table.id;
                    colBody.id = columnId;
                    // Generate unique constraint name and store in internal_meta
                    const internalMeta = this.storeUniqueConstraintNameInInternalMeta(context, {
                        base_id: context.base_id,
                        fk_model_id: table.id,
                        id: columnId
                    });
                    colBody.internal_meta = internalMeta;
                    // Create the physical column in the database
                    const tableUpdateBody = _extends({}, table, {
                        tn: table.table_name,
                        originalColumns: table.columns.map((c)=>_extends({}, c, {
                                cn: c.column_name
                            })),
                        columns: [
                            ...table.columns.map((c)=>_extends({}, c, {
                                    cn: c.column_name
                                })),
                            _extends({}, colBody, {
                                cn: colBody.column_name,
                                altered: 1
                            })
                        ]
                    });
                    const sqlMgr = await reuseOrSave('sqlMgr', reuse, async ()=>_ProjectMgrv2.default.getSqlMgr(context, {
                            id: source.base_id
                        }));
                    await sqlMgr.sqlOpPlus(source, 'tableUpdate', tableUpdateBody);
                    // Save the column metadata
                    savedColumn = await _models.Column.insert(context, _extends({}, colBody, {
                        fk_model_id: table.id
                    }));
                }
                break;
            case _nocodbsdk.UITypes.Formula:
                try {
                    const relatedModels = await (0, _getRelatedModelMap.getRelatedModelMap)(context, table);
                    colBody.formula = await (0, _nocodbsdk.substituteColumnAliasWithIdInFormula)(colBody.formula_raw || colBody.formula, table.columns);
                    colBody.parsed_tree = await (0, _nocodbsdk.validateFormulaAndExtractTreeWithType)({
                        // formula may include double curly brackets in previous version
                        // convert to single curly bracket here for compatibility
                        formula: colBody.formula,
                        column: _extends({}, colBody, {
                            colOptions: colBody
                        }),
                        columns: table.columns,
                        clientOrSqlUi: source.type,
                        getMeta: async (_, { id })=>{
                            return relatedModels.get(id);
                        }
                    });
                    const baseModel = await reuseOrSave('baseModel', reuse, async ()=>_models.Model.getBaseModelSQL(context, {
                            id: table.id,
                            dbDriver: await reuseOrSave('dbDriver', reuse, async ()=>_NcConnectionMgrv2.default.get(source))
                        }));
                    await (0, _formulaQueryBuilderv2.default)({
                        baseModel: baseModel,
                        tree: colBody.formula,
                        model: table,
                        column: null,
                        validateFormula: true,
                        parsedTree: colBody.parsed_tree
                    });
                } catch (e) {
                    colBody.error = e.message;
                    colBody.parsed_tree = null;
                    if (!param.suppressFormulaError) {
                        if (e instanceof _catchError.NcError || e instanceof _nocodbsdk.NcBaseError) throw e;
                        this.logger.error('Error updating column', e);
                        _catchError.NcError.get(context).internalServerError('Failed to update column');
                    }
                }
                savedColumn = await _models.Column.insert(context, _extends({}, colBody, {
                    fk_model_id: table.id
                }));
                break;
            case _nocodbsdk.UITypes.Button:
                {
                    if (colBody.type === _nocodbsdk.ButtonActionsType.Url) {
                        try {
                            const relatedModels = await (0, _getRelatedModelMap.getRelatedModelMap)(context, table);
                            colBody.formula = await (0, _nocodbsdk.substituteColumnAliasWithIdInFormula)(colBody.formula_raw || colBody.formula, table.columns);
                            colBody.parsed_tree = await (0, _nocodbsdk.validateFormulaAndExtractTreeWithType)({
                                formula: colBody.formula,
                                columns: table.columns,
                                column: _extends({}, colBody, {
                                    colOptions: colBody
                                }),
                                clientOrSqlUi: source.type,
                                getMeta: async (_, { id })=>{
                                    return relatedModels.get(id);
                                }
                            });
                            const baseModel = await reuseOrSave('baseModel', reuse, async ()=>_models.Model.getBaseModelSQL(context, {
                                    id: table.id,
                                    dbDriver: await reuseOrSave('dbDriver', reuse, async ()=>_NcConnectionMgrv2.default.get(source))
                                }));
                            await (0, _formulaQueryBuilderv2.default)({
                                baseModel: baseModel,
                                tree: colBody.formula,
                                model: table,
                                column: null,
                                validateFormula: true,
                                parsedTree: colBody.parsed_tree
                            });
                        } catch (e) {
                            colBody.error = e.message;
                            colBody.parsed_tree = null;
                            if (!param.suppressFormulaError) {
                                _catchError.NcError.get(context).invalidRequestBody('Invalid URL Formula');
                            }
                        }
                    } else if (colBody.type === _nocodbsdk.ButtonActionsType.Webhook) {
                        if (!colBody.fk_webhook_id) {
                            colBody.fk_webhook_id = null;
                        }
                        const hook = await _models.Hook.get(context, colBody.fk_webhook_id);
                        if (!hook || !hook.active || hook.event !== 'manual') {
                            colBody.fk_webhook_id = null;
                        }
                    } else if (colBody.type === _nocodbsdk.ButtonActionsType.Script) {
                        if (!colBody.fk_script_id) {
                            colBody.fk_script_id = null;
                        }
                        const script = await _models.Script.get(context, colBody.fk_script_id);
                        if (!script) {
                            colBody.fk_script_id = null;
                        }
                    } else if (colBody.type === _nocodbsdk.ButtonActionsType.Ai) {
                        /*
            Substitute column alias with id in prompt
          */ if (colBody.formula_raw) {
                            await table.getColumns(context);
                            colBody.formula = colBody.formula_raw.replace(/{(.*?)}/g, (match, p1)=>{
                                const column = table.columns.find((c)=>c.title === p1);
                                if (!column) {
                                    _catchError.NcError.get(context).invalidRequestBody(`Field '${p1}' not found`);
                                }
                                return `{${column.id}}`;
                            });
                        }
                    }
                    savedColumn = await _models.Column.insert(context, _extends({}, colBody, {
                        fk_model_id: table.id
                    }));
                    break;
                }
            case _nocodbsdk.UITypes.CreatedTime:
            case _nocodbsdk.UITypes.LastModifiedTime:
            case _nocodbsdk.UITypes.CreatedBy:
            case _nocodbsdk.UITypes.LastModifiedBy:
                {
                    let columnName;
                    const columns = await table.getColumns(context);
                    // check if column already exists, then just create a new column in meta
                    // else create a new column in meta and db
                    const existingColumn = columns.find((c)=>c.uidt === colBody.uidt && c.system);
                    if (!existingColumn) {
                        let columnTitle;
                        switch(colBody.uidt){
                            case _nocodbsdk.UITypes.CreatedTime:
                                columnName = 'created_at';
                                columnTitle = 'CreatedAt';
                                break;
                            case _nocodbsdk.UITypes.LastModifiedTime:
                                columnName = 'updated_at';
                                columnTitle = 'UpdatedAt';
                                break;
                            case _nocodbsdk.UITypes.CreatedBy:
                                columnName = 'created_by';
                                columnTitle = 'nc_created_by';
                                break;
                            case _nocodbsdk.UITypes.LastModifiedBy:
                                columnName = 'updated_by';
                                columnTitle = 'nc_updated_by';
                                break;
                        }
                        // todo:  check type as well
                        const dbColumn = columns.find((c)=>c.column_name === columnName);
                        if (dbColumn) {
                            columnName = (0, _getUniqueName.getUniqueColumnName)(columns, columnName);
                        }
                        {
                            // Preserve original cdf before getColumnPropsFromUIDT potentially overwrites it
                            const preservedCdf = colBody.cdf;
                            colBody = await (0, _getColumnPropsFromUIDT.default)(colBody, source);
                            // Restore original cdf if it was set (getColumnPropsFromUIDT sets it to null by default)
                            if (preservedCdf !== undefined && preservedCdf !== null) {
                                colBody.cdf = preservedCdf;
                            }
                            // remove default value for SQLite since it doesn't support default value as function when adding column
                            // only support default value as constant value
                            if (source.type === 'sqlite3') {
                                colBody.cdf = null;
                            }
                            // create column in db
                            const tableUpdateBody = _extends({}, table, {
                                tn: table.table_name,
                                originalColumns: table.columns.map((c)=>_extends({}, c, {
                                        cn: c.column_name
                                    })),
                                columns: [
                                    ...table.columns.map((c)=>_extends({}, c, {
                                            cn: c.column_name
                                        })),
                                    _extends({}, colBody, {
                                        cn: columnName,
                                        altered: 1
                                    })
                                ]
                            });
                            const sqlMgr = await reuseOrSave('sqlMgr', reuse, async ()=>_ProjectMgrv2.default.getSqlMgr(context, {
                                    id: source.base_id
                                }));
                            await sqlMgr.sqlOpPlus(source, 'tableUpdate', tableUpdateBody);
                        }
                        const title = (0, _getUniqueName.getUniqueColumnAliasName)(table.columns, columnTitle);
                        await _models.Column.insert(context, _extends({}, colBody, {
                            title,
                            system: 1,
                            fk_model_id: table.id,
                            column_name: columnName
                        }));
                    } else {
                        columnName = existingColumn.column_name;
                    }
                    savedColumn = await _models.Column.insert(context, _extends({}, colBody, {
                        fk_model_id: table.id,
                        column_name: null
                    }));
                }
                break;
            default:
                {
                    // Preserve original cdf before getColumnPropsFromUIDT potentially overwrites it
                    const preservedCdf = colBody.cdf;
                    colBody = await (0, _getColumnPropsFromUIDT.default)(colBody, source);
                    // Restore original cdf if it was set (getColumnPropsFromUIDT sets it to null by default)
                    if (preservedCdf !== undefined && preservedCdf !== null) {
                        colBody.cdf = preservedCdf;
                    }
                    if (colBody.uidt === _nocodbsdk.UITypes.Duration) {
                        colBody.dtxp = '20';
                        // by default, colBody.dtxs is 2
                        // Duration column needs more that that
                        colBody.dtxs = '4';
                    }
                    if ([
                        _nocodbsdk.UITypes.SingleSelect,
                        _nocodbsdk.UITypes.MultiSelect
                    ].includes(colBody.uidt)) {
                        var _colBody_colOptions;
                        if (!((_colBody_colOptions = colBody.colOptions) == null ? void 0 : _colBody_colOptions.options)) {
                            colBody.colOptions = _extends({}, colBody.colOptions, {
                                options: []
                            });
                        }
                        const dbDriver = await _NcConnectionMgrv2.default.get(source);
                        const driverType = dbDriver.clientType();
                        const optionTitles = colBody.colOptions.options.map((el)=>el.title.replace(/'/g, "''"));
                        // this is not used for select columns and cause issue for MySQL
                        colBody.dtxs = '';
                        // Handle default values
                        if (colBody.cdf) {
                            if (colBody.uidt === _nocodbsdk.UITypes.SingleSelect) {
                                try {
                                    if (!optionTitles.includes(colBody.cdf.replace(/'/g, "''"))) {
                                        _catchError.NcError.get(context).invalidRequestBody(`Default value '${colBody.cdf}' is not a select option.`);
                                    }
                                } catch (e) {
                                    colBody.cdf = colBody.cdf.replace(/^'/, '').replace(/'$/, '');
                                    if (!optionTitles.includes(colBody.cdf.replace(/'/g, "''"))) {
                                        _catchError.NcError.get(context).invalidRequestBody(`Default value '${colBody.cdf}' is not a select option.`);
                                    }
                                }
                            } else {
                                try {
                                    for (const cdf of colBody.cdf.split(',')){
                                        if (!optionTitles.includes(cdf.replace(/'/g, "''"))) {
                                            _catchError.NcError.get(context).invalidRequestBody(`Default value '${cdf}' is not a select option.`);
                                        }
                                    }
                                } catch (e) {
                                    colBody.cdf = colBody.cdf.replace(/^'/, '').replace(/'$/, '');
                                    for (const cdf of colBody.cdf.split(',')){
                                        if (!optionTitles.includes(cdf.replace(/'/g, "''"))) {
                                            _catchError.NcError.get(context).invalidRequestBody(`Default value '${cdf}' is not a select option.`);
                                        }
                                    }
                                }
                            }
                            // handle single quote for default value
                            if (driverType === 'pg' || driverType === 'sqlite3') {
                                colBody.cdf = colBody.cdf.replace(/'/g, "'");
                            } else {
                                colBody.cdf = colBody.cdf.replace(/'/g, "''");
                            }
                            if (driverType === 'pg') {
                                colBody.cdf = `'${colBody.cdf}'`;
                            }
                        }
                        // Restrict duplicates
                        const titles = colBody.colOptions.options.map((el)=>el.title);
                        if (titles.some(function(item) {
                            return titles.indexOf(item) !== titles.lastIndexOf(item);
                        })) {
                            _catchError.NcError.get(context).invalidRequestBody('Duplicates are not allowed!');
                        }
                        // Restrict empty options
                        if (titles.some(function(item) {
                            return item === '';
                        })) {
                            _catchError.NcError.get(context).invalidRequestBody('Empty options are not allowed!');
                        }
                        // Trim end of enum/set
                        if (colBody.dt === 'enum' || colBody.dt === 'set') {
                            for (const opt of colBody.colOptions.options){
                                opt.title = opt.title.trimEnd();
                            }
                        }
                        if (colBody.uidt === _nocodbsdk.UITypes.SingleSelect) {
                            var _colBody_colOptions1;
                            colBody.dtxp = ((_colBody_colOptions1 = colBody.colOptions) == null ? void 0 : _colBody_colOptions1.options.length) ? `${colBody.colOptions.options.map((o)=>`'${o.title.replace(/'/gi, "''")}'`).join(',')}` : '';
                        } else if (colBody.uidt === _nocodbsdk.UITypes.MultiSelect) {
                            var _colBody_colOptions2;
                            colBody.dtxp = ((_colBody_colOptions2 = colBody.colOptions) == null ? void 0 : _colBody_colOptions2.options.length) ? `${colBody.colOptions.options.map((o)=>{
                                if (o.title.includes(',')) {
                                    _catchError.NcError.get(context).invalidRequestBody("Illegal char(',') for MultiSelect");
                                }
                                return `'${o.title.replace(/'/gi, "''")}'`;
                            }).join(',')}` : '';
                        }
                        // Handle empty enum/set for mysql (we restrict empty user options beforehand)
                        if (driverType === 'mysql' || driverType === 'mysql2') {
                            if (!colBody.colOptions.options.length && (!colBody.dtxp || colBody.dtxp === '')) {
                                colBody.dtxp = "''";
                            }
                            if (colBody.dt === 'set') {
                                var _colBody_colOptions3;
                                if (((_colBody_colOptions3 = colBody.colOptions) == null ? void 0 : _colBody_colOptions3.options.length) > 64) {
                                    colBody.dt = 'text';
                                }
                            }
                        }
                    }
                    if (colBody.uidt === _nocodbsdk.UITypes.User) {
                        // handle default value for user column
                        if (colBody.cdf) {
                            const baseUsers = await _models.BaseUser.getUsersList(context, {
                                base_id: base.id,
                                include_ws_deleted: false
                            });
                            const emailOrIds = colBody.cdf.split(',');
                            const emailsNotPresent = emailOrIds.filter((el)=>{
                                return !baseUsers.find((user)=>user.id === el || user.email === el);
                            });
                            if (emailsNotPresent.length) {
                                _catchError.NcError.get(context).invalidRequestBody(`The following default users are not part of workspace: ${emailsNotPresent.join(', ')}`);
                            }
                            const ids = emailOrIds.map((el)=>{
                                const user = baseUsers.find((user)=>user.id === el || user.email === el);
                                return user.id;
                            });
                            colBody.cdf = ids.join(',');
                        }
                    }
                    if ((0, _nocodbsdk.isAIPromptCol)(colBody)) {
                        let prompt = '';
                        /*
            Substitute column alias with id in prompt
          */ if (colBody.prompt_raw) {
                            await table.getColumns(context);
                            prompt = colBody.prompt_raw.replace(/{(.*?)}/g, (match, p1)=>{
                                const column = table.columns.find((c)=>c.title === p1);
                                if (!column) {
                                    _catchError.NcError.get(context).invalidRequestBody(`Field '${p1}' not found`);
                                }
                                return `{${column.id}}`;
                            });
                        }
                        colBody.prompt = prompt;
                    }
                    // For columns with unique constraint, generate column ID upfront
                    // Then use the column ID to generate the constraint name before SQL operation
                    let columnId = null;
                    if (originalUnique && !(0, _nocodbsdk.isVirtualCol)(param.column)) {
                        // Generate column ID upfront
                        columnId = await ncMeta.genNanoid(_globals.MetaTable.COLUMNS);
                        // Set base_id and fk_model_id in colBody so SQL client can use them
                        colBody.base_id = context.base_id;
                        colBody.fk_model_id = table.id;
                        colBody.id = columnId;
                        // Use helper function with the generated column ID to set up internal_meta
                        // Create a temporary column-like object for the method
                        const tempColumn = {
                            base_id: context.base_id,
                            fk_model_id: table.id,
                            id: columnId
                        };
                        const internalMeta = this.storeUniqueConstraintNameInInternalMeta(context, tempColumn);
                        // Store in colBody (will be passed to SQL client and Column.insert)
                        colBody.internal_meta = internalMeta;
                    }
                    const tableUpdateBody = _extends({}, table, {
                        tn: table.table_name,
                        originalColumns: table.columns.map((c)=>_extends({}, c, {
                                cn: c.column_name
                            })),
                        columns: [
                            ...table.columns.map((c)=>_extends({}, c, {
                                    cn: c.column_name
                                })),
                            _extends({}, colBody, {
                                cn: colBody.column_name,
                                altered: 1
                            })
                        ]
                    });
                    const sqlClient = await reuseOrSave('sqlClient', reuse, async ()=>_NcConnectionMgrv2.default.getSqlClient(source));
                    const sqlMgr = await reuseOrSave('sqlMgr', reuse, async ()=>_ProjectMgrv2.default.getSqlMgr(context, {
                            id: source.base_id
                        }));
                    await sqlMgr.sqlOpPlus(source, 'tableUpdate', tableUpdateBody);
                    if (!source.isMeta()) {
                        var _data, _this, _source_getConfig;
                        const columns = (_this = await sqlClient.columnList({
                            tn: table.table_name,
                            schema: (_source_getConfig = source.getConfig()) == null ? void 0 : _source_getConfig.schema
                        })) == null ? void 0 : (_data = _this.data) == null ? void 0 : _data.list;
                        const insertedColumnMeta = columns.find((c)=>c.cn === colBody.column_name) || {};
                        Object.assign(colBody, insertedColumnMeta);
                    }
                    // Insert column with pre-generated ID if available (for unique constraint)
                    savedColumn = await _models.Column.insert(context, _extends({}, colBody, {
                        fk_model_id: table.id
                    }, columnId ? {
                        id: columnId
                    } : {}));
                }
                break;
        }
        const defaultView = await _models.View.getFirstCollaborativeView(context, table.id, ncMeta);
        await table.getColumns(context, undefined, defaultView == null ? void 0 : defaultView.id);
        const newColumn = table.columns.find((c)=>c.title === param.column.title);
        if (!(0, _nocodbsdk.isLinksOrLTAR)(param.column)) {
            this.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_CREATE, {
                table,
                column: _extends({}, param.column, {
                    fk_model_id: table.id,
                    id: newColumn == null ? void 0 : newColumn.id
                }),
                columnId: newColumn == null ? void 0 : newColumn.id,
                req: param.req,
                context,
                columns: table.columns
            });
        }
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'column_add',
                payload: {
                    table,
                    column: newColumn
                }
            }
        }, context.socket_id);
        if (param.apiVersion === _nocodbsdk.NcApiVersion.V3) {
            if (savedColumn) return await _models.Column.get(context, {
                colId: savedColumn.id
            });
            if (param.column.title) {
                var _table_columns_find;
                return await _models.Column.get(context, {
                    colId: (_table_columns_find = table.columns.find((c)=>c.title === param.column.title)) == null ? void 0 : _table_columns_find.id
                });
            }
        }
        await columnWebhookManager.addNewColumnById({
            columnId: newColumn.id,
            action: _nocodbsdk.WebhookActions.INSERT
        });
        if (!param.columnWebhookManager) {
            columnWebhookManager.emit();
        }
        return table;
    }
    async columnDelete(context, param, ncMeta = this.metaService) {
        var _param_columnWebhookManager;
        const reuse = param.reuse || {};
        const column = await _models.Column.get(context, {
            colId: param.columnId
        }, ncMeta);
        if (!column) {
            _catchError.NcError.get(context).fieldNotFound(param.columnId);
        }
        const { applyRowColorInvolvement } = await this.viewRowColorService.checkIfColumnInvolved({
            context,
            existingColumn: column,
            action: 'delete',
            ncMeta
        });
        if ((column.system || (0, _nocodbsdk.isSystemColumn)(column)) && !param.forceDeleteSystem) {
            _catchError.NcError.get(context).invalidRequestBody(`The column '${column.title || column.column_name}' is a system column and cannot be deleted.`);
        }
        const table = await reuseOrSave('table', reuse, async ()=>_models.Model.getWithInfo(context, {
                id: column.fk_model_id
            }, ncMeta));
        const source = await reuseOrSave('source', reuse, async ()=>_models.Source.get(context, table.source_id, false, ncMeta));
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        // check if source is readonly and column type is not allowed
        if ((source == null ? void 0 : source.is_schema_readonly) && !_nocodbsdk.readonlyMetaAllowedTypes.includes(column.uidt)) {
            _catchError.NcError.get(context).sourceMetaReadOnly(source.alias);
        }
        if (table.synced && column.readonly && !param.forceDeleteSystem) {
            _catchError.NcError.get(context).invalidRequestBody(`The column '${column.title || column.column_name}' is a synced column and cannot be deleted.`);
        }
        const columnWebhookManager = (_param_columnWebhookManager = param.columnWebhookManager) != null ? _param_columnWebhookManager : (await (await new _columnwebhookmanager.ColumnWebhookManagerBuilder(context, ncMeta).withModelId(column.fk_model_id)).addColumnById(column.id)).forDelete();
        const sqlMgr = await reuseOrSave('sqlMgr', reuse, async ()=>_ProjectMgrv2.default.getSqlMgr(context, {
                id: source.base_id
            }, ncMeta));
        // check column association with any custom links or LTAR
        if (!(0, _nocodbsdk.isVirtualCol)(column)) {
            var _columns_find;
            const columns = await table.getColumns(context, ncMeta);
            let link = (_columns_find = columns.find((c)=>{
                var _c_colOptions, _c_colOptions1, _c_colOptions2, _c_colOptions3;
                return (0, _nocodbsdk.isLinksOrLTAR)(c.uidt) && (((_c_colOptions = c.colOptions) == null ? void 0 : _c_colOptions.fk_child_column_id) === param.columnId || ((_c_colOptions1 = c.colOptions) == null ? void 0 : _c_colOptions1.fk_parent_column_id) === param.columnId || ((_c_colOptions2 = c.colOptions) == null ? void 0 : _c_colOptions2.fk_mm_child_column_id) === param.columnId || ((_c_colOptions3 = c.colOptions) == null ? void 0 : _c_colOptions3.fk_mm_parent_column_id) === param.columnId);
            })) == null ? void 0 : _columns_find.colOptions;
            if (!link) {
                link = await ncMeta.metaGet2(table.fk_workspace_id, table.base_id, _globals.MetaTable.COL_RELATIONS, {}, null, {
                    _or: [
                        {
                            fk_child_column_id: {
                                eq: param.columnId
                            }
                        },
                        {
                            fk_parent_column_id: {
                                eq: param.columnId
                            }
                        },
                        {
                            fk_mm_child_column_id: {
                                eq: param.columnId
                            }
                        },
                        {
                            fk_mm_parent_column_id: {
                                eq: param.columnId
                            }
                        }
                    ]
                });
            }
            // if relation found then throw error
            if (link) {
                const linkCol = await _models.Column.get(context, {
                    colId: link.fk_column_id
                }, ncMeta);
                const table = await linkCol.getModel(context, ncMeta);
                _catchError.NcError.get(context).columnAssociatedWithLink(column.id, {
                    customMessage: `Column is associated with Link column '${linkCol.title || linkCol.column_name}' (${table.title || table.table_name}). Please delete the link column first.`
                });
            }
        }
        /**
     * @Note: When using 'falls through to default' cases in a switch statement,
     * it is crucial to place them after cases with break statements.
     * Additionally, include a check for column.uidt inside these 'falls through to default' cases
     * to conditionally execute logic based on the value of column.uidt.
     *
     * This check becomes essential when there are multiple 'falls through to default' cases.
     * By adding the column.uidt check, we ensure that each case has its own specific conditions.
     * This prevents unintended execution of logic from subsequent cases due to fall-through,
     * providing a more controlled and predictable behavior in the switch statement.
     */ switch(column.uidt){
            case _nocodbsdk.UITypes.Lookup:
            case _nocodbsdk.UITypes.Rollup:
            case _nocodbsdk.UITypes.QrCode:
            case _nocodbsdk.UITypes.Barcode:
            case _nocodbsdk.UITypes.Button:
                // PR review fix #3: UUID removed from this group — it has a physical DB column
                // and must go through the default path (sqlOpPlus + tableUpdate) to drop it.
                await _models.Column.delete2(context, _extends({
                    id: param.columnId
                }, generateColumnDeleteHandler(columnWebhookManager)), ncMeta);
                break;
            case _nocodbsdk.UITypes.Formula:
                var _column_colOptions_parsed_tree;
                if (!column.colOptions) await column.getColOptions(context, ncMeta);
                if (((_column_colOptions_parsed_tree = column.colOptions.parsed_tree) == null ? void 0 : _column_colOptions_parsed_tree.dataType) === _nocodbsdk.FormulaDataTypes.DATE) {
                    var _this;
                    if ((_this = await _models.CalendarRange.IsColumnBeingUsedAsRange(context, column.id, ncMeta)) == null ? void 0 : _this.length) {
                        _catchError.NcError.get(context).badRequest(`The column '${column.title}' is being used in Calendar View. Please update Calendar View first.`);
                    }
                }
                await _models.Column.delete(context, param.columnId, ncMeta);
                break;
            // on deleting created/last modified columns, keep the column in table and delete the column from meta
            case _nocodbsdk.UITypes.CreatedTime:
            case _nocodbsdk.UITypes.LastModifiedTime:
                {
                    const rangesList = await _models.CalendarRange.IsColumnBeingUsedAsRange(context, column.id, ncMeta);
                    if (rangesList == null ? void 0 : rangesList.length) {
                        _catchError.NcError.get(context).badRequest(`The column '${column.title}' is being used in Calendar View. Please update Calendar View first.`);
                    }
                    await _models.Column.delete2(context, _extends({
                        id: param.columnId
                    }, generateColumnDeleteHandler(columnWebhookManager)), ncMeta);
                    break;
                }
            case _nocodbsdk.UITypes.CreatedBy:
            case _nocodbsdk.UITypes.LastModifiedBy:
                {
                    await _models.Column.delete2(context, _extends({
                        id: param.columnId
                    }, generateColumnDeleteHandler(columnWebhookManager)), ncMeta);
                    break;
                }
            // Since Links is just an extended version of LTAR, we can use the same logic
            case _nocodbsdk.UITypes.Links:
            case _nocodbsdk.UITypes.LinkToAnotherRecord:
                {
                    var _column_meta;
                    const relationColOpt = await column.getColOptions(context, ncMeta);
                    const { childContext, parentContext, mmContext } = await relationColOpt.getParentChildContext(context);
                    const childColumn = await relationColOpt.getChildColumn(childContext, ncMeta);
                    const childTable = await childColumn.getModel(childContext, ncMeta);
                    const parentColumn = await relationColOpt.getParentColumn(parentContext, ncMeta);
                    const parentTable = await parentColumn.getModel(parentContext, ncMeta);
                    const custom = (_column_meta = column.meta) == null ? void 0 : _column_meta.custom;
                    const isMMLike = (0, _nocodbsdk.isMMOrMMLike)(column);
                    const relationType = isMMLike ? 'mm' : relationColOpt.type;
                    switch(relationType){
                        case 'bt':
                        case 'hm':
                            {
                                await this.deleteHmOrBtRelation(context, {
                                    column,
                                    relationColOpt,
                                    source,
                                    childColumn,
                                    childTable,
                                    parentColumn,
                                    parentTable,
                                    sqlMgr,
                                    ncMeta,
                                    custom,
                                    req: param.req,
                                    childContext,
                                    parentContext,
                                    columnWebhookManager
                                });
                            }
                            break;
                        case 'oo':
                            {
                                await this.deleteOoRelation(context, {
                                    relationColOpt,
                                    req: param.req,
                                    source,
                                    childColumn,
                                    childTable,
                                    parentColumn,
                                    parentTable,
                                    sqlMgr,
                                    ncMeta,
                                    custom,
                                    childContext,
                                    parentContext,
                                    column,
                                    columnWebhookManager
                                });
                            }
                            break;
                        case 'mm':
                            {
                                const mmTable = await relationColOpt.getMMModel(mmContext, ncMeta);
                                const mmParentCol = await relationColOpt.getMMParentColumn(mmContext, ncMeta);
                                const mmChildCol = await relationColOpt.getMMChildColumn(mmContext, ncMeta);
                                if (!custom) {
                                    await this.deleteHmOrBtRelation(context, {
                                        relationColOpt: null,
                                        parentColumn: parentColumn,
                                        childTable: mmTable,
                                        sqlMgr,
                                        parentTable: parentTable,
                                        childColumn: mmParentCol,
                                        source,
                                        ncMeta,
                                        virtual: !!relationColOpt.virtual,
                                        req: param.req,
                                        childContext: mmContext,
                                        parentContext,
                                        columnWebhookManager
                                    }, true);
                                    await this.deleteHmOrBtRelation(context, {
                                        relationColOpt: null,
                                        parentColumn: childColumn,
                                        childTable: mmTable,
                                        sqlMgr,
                                        parentTable: childTable,
                                        childColumn: mmChildCol,
                                        source,
                                        ncMeta,
                                        virtual: !!relationColOpt.virtual,
                                        req: param.req,
                                        childContext: mmContext,
                                        parentContext: childContext,
                                        columnWebhookManager
                                    }, true);
                                }
                                const { refContext } = relationColOpt.getRelContext(context);
                                const refTable = await relationColOpt.getRelatedTable(refContext, ncMeta);
                                const columnsInRelatedTable = await refTable.getColumns(refContext, ncMeta);
                                for (const c of columnsInRelatedTable){
                                    if (!(0, _nocodbsdk.isLinksOrLTAR)(c.uidt)) continue;
                                    const colOpt = await c.getColOptions(refContext, ncMeta);
                                    if ((0, _nocodbsdk.isMMOrMMLike)(c) && colOpt.fk_parent_column_id === childColumn.id && colOpt.fk_child_column_id === parentColumn.id && colOpt.fk_mm_model_id === relationColOpt.fk_mm_model_id && colOpt.fk_mm_parent_column_id === relationColOpt.fk_mm_child_column_id && colOpt.fk_mm_child_column_id === relationColOpt.fk_mm_parent_column_id) {
                                        await _models.Column.delete2(refContext, _extends({
                                            id: c.id
                                        }, generateColumnDeleteHandler(columnWebhookManager)), ncMeta);
                                        if (!c.system) {
                                            this.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_DELETE, {
                                                table: refTable,
                                                column: c,
                                                req: param.req,
                                                context: refContext,
                                                columnId: c.id,
                                                columns: await refTable.getCachedColumns(refContext)
                                            });
                                        }
                                        break;
                                    }
                                }
                                await _models.Column.delete2(context, _extends({
                                    id: relationColOpt.fk_column_id
                                }, generateColumnDeleteHandler(columnWebhookManager)), ncMeta);
                                const table = column.fk_model_id === parentTable.id ? parentTable : childTable;
                                const tblContext = column.fk_model_id === parentTable.id ? parentContext : childContext;
                                this.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_DELETE, {
                                    table,
                                    column: column,
                                    req: param.req,
                                    context: tblContext,
                                    columnId: column.id,
                                    columns: await table.getCachedColumns(context)
                                });
                                if (!custom) {
                                    if (mmTable) {
                                        // delete bt columns in m2m table
                                        await mmTable.getColumns(mmContext, ncMeta);
                                        for (const c of mmTable.columns){
                                            if (!(0, _nocodbsdk.isLinksOrLTAR)(c.uidt)) continue;
                                            const colOpt = await c.getColOptions(mmContext, ncMeta);
                                            if (colOpt.type === 'bt') {
                                                await _models.Column.delete2(mmContext, _extends({
                                                    id: c.id
                                                }, generateColumnDeleteHandler(columnWebhookManager)), ncMeta);
                                            }
                                        }
                                    }
                                    // delete hm columns in parent table
                                    await parentTable.getColumns(parentContext, ncMeta);
                                    for (const c of parentTable.columns){
                                        if (!(0, _nocodbsdk.isLinksOrLTAR)(c.uidt)) continue;
                                        const colOpt = await c.getColOptions(parentContext, ncMeta);
                                        if (colOpt.fk_related_model_id === relationColOpt.fk_mm_model_id) {
                                            await _models.Column.delete2(parentContext, _extends({
                                                id: c.id
                                            }, generateColumnDeleteHandler(columnWebhookManager)), ncMeta);
                                        }
                                    }
                                    // delete hm columns in child table
                                    await childTable.getColumns(childContext, ncMeta);
                                    for (const c of childTable.columns){
                                        if (!(0, _nocodbsdk.isLinksOrLTAR)(c.uidt)) continue;
                                        const colOpt = await c.getColOptions(childContext, ncMeta);
                                        if (colOpt.fk_related_model_id === relationColOpt.fk_mm_model_id) {
                                            await _models.Column.delete2(context, _extends({
                                                id: c.id
                                            }, generateColumnDeleteHandler(columnWebhookManager)), ncMeta);
                                        }
                                    }
                                    // delete m2m table if it is made for mm relation
                                    if (mmTable == null ? void 0 : mmTable.mm) {
                                        // retrieve columns in m2m table again
                                        await mmTable.getColumns(mmContext, ncMeta);
                                        // ignore deleting table if it has more than 2 columns
                                        // the expected 2 columns would be table1_id & table2_id
                                        if (mmTable.columns.length === 2) {
                                            const mmSource = relationColOpt.fk_mm_source_id && relationColOpt.fk_mm_source_id !== source.id ? await _models.Source.get(mmContext, relationColOpt.fk_mm_source_id, undefined, ncMeta) : source;
                                            mmTable.tn = mmTable.table_name;
                                            await sqlMgr.sqlOpPlus(mmSource, 'tableDelete', mmTable);
                                            await mmTable.delete(mmContext, ncMeta);
                                        }
                                    }
                                }
                                if (custom) {
                                    // if custom then delete the relation index
                                    await this.deleteCustomLinkIndex(context, {
                                        ltarCustomProps: {
                                            column_id: relationColOpt.fk_child_column_id,
                                            ref_column_id: relationColOpt.fk_parent_column_id,
                                            ref_model_id: relationColOpt.fk_related_model_id,
                                            junc_column_id: relationColOpt.fk_mm_child_column_id,
                                            junc_model_id: relationColOpt.fk_mm_model_id,
                                            junc_ref_column_id: relationColOpt.fk_mm_parent_column_id
                                        },
                                        reuse,
                                        isMm: relationColOpt.type === _nocodbsdk.RelationTypes.MANY_TO_MANY,
                                        source
                                    });
                                }
                            }
                            break;
                    }
                }
                this.appHooksService.emit(_nocodbsdk.AppEvents.RELATION_DELETE, {
                    column,
                    req: param.req,
                    context
                });
                break;
            case _nocodbsdk.UITypes.ForeignKey:
                {
                    _catchError.NcError.get(context).notImplemented(`Support for ${column.uidt}`);
                    break;
                }
            case _nocodbsdk.UITypes.SingleSelect:
                {
                    if ((await _models.KanbanView.getViewsByGroupingColId(context, column.id)).length > 0) {
                        _catchError.NcError.get(context).badRequest(`The column '${column.title}' is being used in Kanban View. Please update Kanban View first.`);
                    }
                /* falls through to default */ }
            case _nocodbsdk.UITypes.DateTime:
            case _nocodbsdk.UITypes.Date:
                {
                    const listRanges = await _models.CalendarRange.IsColumnBeingUsedAsRange(context, column.id, ncMeta);
                    if (listRanges == null ? void 0 : listRanges.length) {
                        _catchError.NcError.get(context).badRequest(`The column '${column.title}' is being used in Calendar View. Please update Calendar View first.`);
                    }
                /* falls through to default */ }
            default:
                {
                    const tableUpdateBody = _extends({}, table, {
                        tn: table.table_name,
                        originalColumns: table.columns.map((c)=>_extends({}, c, {
                                cn: c.column_name,
                                cno: c.column_name
                            })),
                        columns: table.columns.map((c)=>{
                            if (c.id === param.columnId) {
                                return _extends({}, c, {
                                    cn: c.column_name,
                                    cno: c.column_name,
                                    altered: 4
                                });
                            } else {
                                c.cn = c.column_name;
                            }
                            return c;
                        })
                    });
                    await sqlMgr.sqlOpPlus(source, 'tableUpdate', tableUpdateBody);
                    await _models.Column.delete2(context, _extends({
                        id: param.columnId
                    }, generateColumnDeleteHandler(columnWebhookManager)), ncMeta);
                }
        }
        const defaultView = await _models.View.getFirstCollaborativeView(context, table.id, ncMeta);
        // Pass defaultViewId so that default view column order and visibility get added to the column meta
        await table.getColumns(context, ncMeta, defaultView == null ? void 0 : defaultView.id);
        const displayValueColumn = (0, _mapDefaultDisplayValue.default)(table.columns);
        if (displayValueColumn) {
            await _models.Model.updatePrimaryColumn(context, displayValueColumn.fk_model_id, displayValueColumn.id, ncMeta);
        }
        await _models.View.updateIfColumnUsedAsExpandedMode(context, column.id, column.fk_model_id, ncMeta);
        if (!(0, _nocodbsdk.isLinksOrLTAR)(column)) {
            this.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_DELETE, {
                table,
                column,
                req: param.req,
                context,
                columnId: column.id,
                columns: table.columns
            });
        }
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'column_delete',
                payload: {
                    table,
                    column
                }
            }
        }, context.socket_id);
        await applyRowColorInvolvement();
        await _models.Hook.deleteTriggersByColumnId(context, column.id, ncMeta);
        if (!param.columnWebhookManager) {
            await columnWebhookManager.populateNewColumns();
            columnWebhookManager.emit();
        }
        return table;
    }
    async createLTARColumn(context, param) {
        var _param_reuse, _ref;
        var _param_column, _param_column1;
        let savedColumn;
        (0, _validateParams.default)([
            'parentId',
            'childId',
            'type'
        ], param.column, context);
        const reuse = (_param_reuse = param.reuse) != null ? _param_reuse : {};
        // v2 LTAR uses junction table for all relation types (like mm)
        // v1 is the default - v2 is only used when explicitly requested via version param
        const isMMLike = param.column.version === _nocodbsdk.LinksVersion.V2 || // traditional MM is always treated as MM-like regardless of version
        param.column.type === _nocodbsdk.RelationTypes.MANY_TO_MANY;
        // get table and refTable models
        const table = await _models.Model.getWithInfo(context, {
            id: param.column.parentId
        });
        const refContext = _extends({}, context, {
            base_id: (_ref = (_param_column = param.column) == null ? void 0 : _param_column.ref_base_id) != null ? _ref : context.base_id
        });
        // check permission if cross-base link
        if (table.base_id !== refContext.base_id) {
            await this.checkCrossBasePermission(refContext, param.req.user);
        }
        const refTable = await _models.Model.getWithInfo(refContext, {
            id: param.column.childId
        });
        let refColumn;
        const childView = ((_param_column1 = param.column) == null ? void 0 : _param_column1.childViewId) ? await _models.View.getByTitleOrId(context, {
            fk_model_id: refTable.id,
            titleOrId: param.column.childViewId
        }) : null;
        const sqlMgr = await reuseOrSave('sqlMgr', reuse, async ()=>_ProjectMgrv2.default.getSqlMgr(context, {
                id: param.source.base_id
            }));
        const refSource = param.source.id === refTable.source_id ? param.source : await _models.Source.get(refContext, refTable.source_id);
        // support cross base relations only if the bases are meta bases
        if (param.source.id !== refTable.source_id && (!param.source.isMeta() || !refSource.isMeta())) {
            _catchError.NcError.get(context).badRequest('Cross base relations are only supported between meta bases');
        }
        // Need this since we support relations between tables in different bases
        const refSqlMgr = refTable.base_id === param.source.base_id ? sqlMgr : await _ProjectMgrv2.default.getSqlMgr(context, {
            id: refTable.base_id
        });
        const isLinks = param.column.uidt === _nocodbsdk.UITypes.Links || param.column.type === 'bt';
        // if xcdb base then treat as virtual relation to avoid creating foreign key
        if (param.source.isMeta() || param.source.type === 'snowflake') {
            param.column.virtual = true;
        }
        if (!isMMLike && (param.column.type === 'hm' || param.column.type === 'bt')) {
            // populate fk column name
            const fkColName = (0, _getUniqueName.getUniqueColumnName)(await refTable.getColumns(refContext), `${table.table_name}_id`);
            let foreignKeyName;
            {
                // create foreign key
                const newColumn = {
                    cn: fkColName,
                    title: fkColName,
                    column_name: fkColName,
                    rqd: false,
                    pk: false,
                    ai: false,
                    cdf: null,
                    dt: table.primaryKey.dt,
                    dtxp: table.primaryKey.dtxp,
                    dtxs: table.primaryKey.dtxs,
                    un: table.primaryKey.un,
                    altered: 1
                };
                const tableUpdateBody = _extends({}, refTable, {
                    tn: refTable.table_name,
                    originalColumns: refTable.columns.map((c)=>_extends({}, c, {
                            cn: c.column_name
                        })),
                    columns: [
                        ...refTable.columns.map((c)=>_extends({}, c, {
                                cn: c.column_name
                            })),
                        newColumn
                    ]
                });
                await refSqlMgr.sqlOpPlus(refSource, 'tableUpdate', tableUpdateBody);
                const { id } = await _models.Column.insert(refContext, _extends({}, newColumn, {
                    uidt: _nocodbsdk.UITypes.ForeignKey,
                    fk_model_id: refTable.id
                }));
                refColumn = await _models.Column.get(refContext, {
                    colId: id
                });
                // ignore relation creation if virtual
                if (!param.column.virtual) {
                    foreignKeyName = (0, _helpers.generateFkName)(table, refTable);
                    // create relation
                    await sqlMgr.sqlOpPlus(refSource, 'relationCreate', {
                        childColumn: fkColName,
                        childTable: refTable.table_name,
                        parentTable: table.table_name,
                        onDelete: 'NO ACTION',
                        onUpdate: 'NO ACTION',
                        type: 'real',
                        parentColumn: table.primaryKey.column_name,
                        foreignKeyName
                    });
                }
                // todo: create index for virtual relations as well
                //       create index for foreign key in pg
                if (param.source.type === 'pg' || param.column.virtual) {
                    const indexName = (0, _helpers.generateFkName)(table, refTable);
                    await this.createColumnIndex(refContext, {
                        column: new _models.Column(_extends({}, newColumn, {
                            fk_model_id: refTable.id
                        })),
                        indexName,
                        source: refSource,
                        sqlMgr
                    });
                }
            }
            savedColumn = await (0, _helpers.createHmAndBtColumn)(context, param.req, refTable, table, refColumn, childView, param.column.type, param.column.title, foreignKeyName, param.column.virtual, null, param.column['meta'], isLinks, _extends({}, param.colExtra, {
                readonly: param.column.readonly || false
            }), undefined, undefined, param.columnWebhookManager);
        } else if (!isMMLike && param.column.type === 'oo') {
            // populate fk column name
            const fkColName = (0, _getUniqueName.getUniqueColumnName)(await refTable.getColumns(refContext), `${table.table_name}_id`);
            let foreignKeyName;
            {
                // Create foreign key column for one-to-one relationship
                const newColumn = {
                    cn: fkColName,
                    title: fkColName,
                    column_name: fkColName,
                    rqd: false,
                    pk: false,
                    ai: false,
                    cdf: null,
                    dt: table.primaryKey.dt,
                    dtxp: table.primaryKey.dtxp,
                    dtxs: table.primaryKey.dtxs,
                    un: table.primaryKey.un,
                    altered: 1,
                    unique: 1
                };
                const tableUpdateBody = _extends({}, refTable, {
                    tn: refTable.table_name,
                    originalColumns: refTable.columns.map((c)=>_extends({}, c, {
                            cn: c.column_name
                        })),
                    columns: [
                        ...refTable.columns.map((c)=>_extends({}, c, {
                                cn: c.column_name
                            })),
                        newColumn
                    ]
                });
                await sqlMgr.sqlOpPlus(refSource, 'tableUpdate', tableUpdateBody);
                const { id } = await _models.Column.insert(refContext, _extends({}, newColumn, {
                    uidt: _nocodbsdk.UITypes.ForeignKey,
                    fk_model_id: refTable.id
                }));
                refColumn = await _models.Column.get(refContext, {
                    colId: id
                });
                // ignore relation creation if virtual
                if (!param.column.virtual) {
                    foreignKeyName = (0, _helpers.generateFkName)(table, refTable);
                    // create relation
                    await sqlMgr.sqlOpPlus(refSource, 'relationCreate', {
                        childColumn: fkColName,
                        childTable: refTable.table_name,
                        parentTable: table.table_name,
                        onDelete: 'NO ACTION',
                        onUpdate: 'NO ACTION',
                        type: 'real',
                        parentColumn: table.primaryKey.column_name,
                        foreignKeyName
                    });
                }
                // todo: create index for virtual relations as well
                //       create index for foreign key in pg
                if (param.source.type === 'pg' || param.column.virtual) {
                    const indexName = (0, _helpers.generateFkName)(table, refTable);
                    await this.createColumnIndex(refContext, {
                        column: new _models.Column(_extends({}, newColumn, {
                            fk_model_id: refTable.id
                        })),
                        indexName,
                        source: refSource,
                        sqlMgr
                    });
                }
            }
            savedColumn = await (0, _helpers.createOOColumn)(context, param.req, refTable, table, refColumn, childView, param.column.type, param.column.title, foreignKeyName, param.column.virtual, null, param.column['meta'], _extends({}, param.colExtra, {
                readonly: param.column.readonly || false
            }), undefined, undefined, param.columnWebhookManager);
        } else if (isMMLike || param.column.type === 'mm') {
            var _param_column_title;
            var _param_user, _this, _this1, _param_column_meta, _param_column_meta1, _param_columnWebhookManager, _param_columnWebhookManager1;
            const aTn = await getJunctionTableName(param, table, refTable);
            const aTnAlias = aTn;
            const primaryKey = table.primaryKey;
            const refPrimaryKey = refTable.primaryKey;
            const associateTableCols = [];
            const { parentCn: columnName, childCn: refColumnName } = (0, _helpers.getMMColumnNames)(table, refTable);
            associateTableCols.push({
                cn: refColumnName,
                column_name: refColumnName,
                title: refColumnName,
                rqd: true,
                pk: true,
                ai: false,
                cdf: null,
                dt: refPrimaryKey.dt,
                dtxp: refPrimaryKey.dtxp,
                dtxs: refPrimaryKey.dtxs,
                un: refPrimaryKey.un,
                altered: 1,
                uidt: _nocodbsdk.UITypes.ForeignKey
            }, {
                cn: columnName,
                column_name: columnName,
                title: columnName,
                rqd: true,
                pk: true,
                ai: false,
                cdf: null,
                dt: primaryKey.dt,
                dtxp: primaryKey.dtxp,
                dtxs: primaryKey.dtxs,
                un: primaryKey.un,
                altered: 1,
                uidt: _nocodbsdk.UITypes.ForeignKey
            });
            await sqlMgr.sqlOpPlus(param.source, 'tableCreate', {
                tn: aTn,
                _tn: aTnAlias,
                columns: associateTableCols
            });
            const assocModel = await _models.Model.insert(context, param.base.id, param.source.id, {
                table_name: aTn,
                title: aTnAlias,
                // todo: sanitize
                mm: true,
                columns: associateTableCols,
                user_id: (_param_user = param.user) == null ? void 0 : _param_user.id
            });
            let foreignKeyName1;
            let foreignKeyName2;
            if (!param.column.virtual) {
                foreignKeyName1 = (0, _helpers.generateFkName)(table, refTable);
                foreignKeyName2 = (0, _helpers.generateFkName)(table, refTable);
                const rel1Args = _extends({}, param.column, {
                    childTable: aTn,
                    childColumn: columnName,
                    parentTable: table.table_name,
                    parentColumn: primaryKey.column_name,
                    type: 'real',
                    foreignKeyName: foreignKeyName1
                });
                const rel2Args = _extends({}, param.column, {
                    childTable: aTn,
                    childColumn: refColumnName,
                    parentTable: refTable.table_name,
                    parentColumn: refPrimaryKey.column_name,
                    type: 'real',
                    foreignKeyName: foreignKeyName2
                });
                await sqlMgr.sqlOpPlus(param.source, 'relationCreate', rel1Args);
                await sqlMgr.sqlOpPlus(param.source, 'relationCreate', rel2Args);
            }
            const parentCol = (_this = await assocModel.getColumns(context)) == null ? void 0 : _this.find((c)=>c.column_name === columnName);
            const childCol = (_this1 = await assocModel.getColumns(context)) == null ? void 0 : _this1.find((c)=>c.column_name === refColumnName);
            // todo: skip hm and bt if new type
            await (0, _helpers.createHmAndBtColumn)(context, param.req, assocModel, refTable, childCol, null, null, null, foreignKeyName1, param.column.virtual, true, null, false, param.colExtra, undefined, undefined, // not need to pass columnWebhookManager here
            undefined);
            await (0, _helpers.createHmAndBtColumn)(context, param.req, assocModel, table, parentCol, null, null, null, foreignKeyName2, param.column.virtual, true, null, false, param.colExtra, undefined, undefined, // not need to pass columnWebhookManager here
            undefined);
            let refCrossBaseLinkProps = {};
            let crossBaseLinkProps = {};
            // if cross base link set cross base link props
            if (refContext.base_id !== context.base_id) {
                crossBaseLinkProps = {
                    fk_related_base_id: refContext.base_id,
                    fk_mm_base_id: assocModel.base_id,
                    fk_related_source_id: refTable.source_id,
                    fk_mm_source_id: assocModel.source_id
                };
                refCrossBaseLinkProps = {
                    fk_related_base_id: context.base_id,
                    fk_mm_base_id: assocModel.base_id,
                    fk_related_source_id: table.source_id,
                    fk_mm_source_id: assocModel.source_id
                };
            }
            // Normalize V1 types to V2 equivalents when using junction table
            // HM with junction table is effectively OM, BT with junction table is effectively MO
            let normalizedType = param.column.type;
            if (isMMLike) {
                if (normalizedType === _nocodbsdk.RelationTypes.HAS_MANY) {
                    normalizedType = _nocodbsdk.RelationTypes.ONE_TO_MANY;
                } else if (normalizedType === _nocodbsdk.RelationTypes.BELONGS_TO) {
                    normalizedType = _nocodbsdk.RelationTypes.MANY_TO_ONE;
                }
            }
            const revType = (0, _helpers.getRevType)(normalizedType);
            const relationType = normalizedType;
            // Use singular for ONE_TO_ONE and MANY_TO_ONE, plural for others
            const defaultTitle = [
                _nocodbsdk.RelationTypes.ONE_TO_ONE,
                _nocodbsdk.RelationTypes.MANY_TO_ONE
            ].includes(relationType) ? (0, _inflection.singularize)(refTable.title) : (0, _inflection.pluralize)(refTable.title);
            savedColumn = await _models.Column.insert(context, _extends({
                title: (0, _getUniqueName.getUniqueColumnAliasName)(await table.getColumns(context), (_param_column_title = param.column.title) != null ? _param_column_title : defaultTitle),
                // OO always uses LinkToAnotherRecord (same as V1 createOOColumn)
                uidt: relationType === _nocodbsdk.RelationTypes.ONE_TO_ONE ? _nocodbsdk.UITypes.LinkToAnotherRecord : isLinks ? _nocodbsdk.UITypes.Links : _nocodbsdk.UITypes.LinkToAnotherRecord,
                type: relationType,
                fk_model_id: table.id,
                fk_child_column_id: primaryKey.id,
                fk_parent_column_id: refPrimaryKey.id,
                fk_target_view_id: childView == null ? void 0 : childView.id,
                fk_mm_model_id: assocModel.id,
                fk_mm_child_column_id: parentCol.id,
                fk_mm_parent_column_id: childCol.id,
                fk_related_model_id: refTable.id,
                virtual: param.column.virtual,
                readonly: param.column.readonly || false,
                meta: _extends({}, param.column['meta'] || {}, {
                    plural: ((_param_column_meta = param.column['meta']) == null ? void 0 : _param_column_meta.plural) || (0, _inflection.pluralize)(refTable.title),
                    singular: ((_param_column_meta1 = param.column['meta']) == null ? void 0 : _param_column_meta1.singular) || (0, _inflection.singularize)(refTable.title)
                }),
                version: isMMLike ? 2 : 1
            }, param.colExtra, crossBaseLinkProps));
            // Use singular for ONE_TO_ONE and MANY_TO_ONE, plural for others
            const reverseDefaultTitle = [
                _nocodbsdk.RelationTypes.ONE_TO_ONE,
                _nocodbsdk.RelationTypes.MANY_TO_ONE
            ].includes(revType) ? (0, _inflection.singularize)(table.title) : (0, _inflection.pluralize)(table.title);
            const parentRelCol = await _models.Column.insert(refContext, _extends({
                title: (0, _getUniqueName.getUniqueColumnAliasName)([
                    ...await refTable.getColumns(refContext),
                    // if self ref include saved column
                    ...table.id === refTable.id ? [
                        savedColumn
                    ] : []
                ], reverseDefaultTitle),
                // OO always uses LinkToAnotherRecord (same as V1 createOOColumn)
                uidt: revType === _nocodbsdk.RelationTypes.ONE_TO_ONE ? _nocodbsdk.UITypes.LinkToAnotherRecord : isLinks ? _nocodbsdk.UITypes.Links : _nocodbsdk.UITypes.LinkToAnotherRecord,
                type: revType,
                version: isMMLike ? 2 : 1,
                // ref_db_alias
                fk_model_id: refTable.id,
                // db_type:
                fk_child_column_id: refPrimaryKey.id,
                fk_parent_column_id: primaryKey.id,
                // Adding view ID here applies the view filter in reverse also
                fk_target_view_id: null,
                fk_mm_model_id: assocModel.id,
                fk_mm_child_column_id: childCol.id,
                fk_mm_parent_column_id: parentCol.id,
                fk_related_model_id: table.id,
                virtual: param.column.virtual,
                readonly: param.column.readonly || false,
                meta: {
                    plural: (0, _inflection.pluralize)(table.title),
                    singular: (0, _inflection.singularize)(table.title)
                },
                // if self referencing treat it as system field to hide from ui
                system: table.id === refTable.id
            }, refCrossBaseLinkProps));
            this.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_CREATE, {
                table: refTable,
                column: parentRelCol,
                columnId: parentRelCol.id,
                req: param.req,
                context: refContext,
                columns: await refTable.getCachedColumns(context)
            });
            this.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_CREATE, {
                table: table,
                column: savedColumn,
                columnId: savedColumn.id,
                req: param.req,
                context,
                columns: await table.getCachedColumns(context)
            });
            // todo: create index for virtual relations as well
            // create index for foreign key in pg
            if (param.source.type === 'pg') {
                await this.createColumnIndex(context, {
                    column: new _models.Column(_extends({}, associateTableCols[0], {
                        fk_model_id: assocModel.id
                    })),
                    indexName: (0, _helpers.generateFkName)(table, refTable),
                    source: param.source,
                    sqlMgr
                });
                await this.createColumnIndex(context, {
                    column: new _models.Column(_extends({}, associateTableCols[1], {
                        fk_model_id: assocModel.id
                    })),
                    indexName: (0, _helpers.generateFkName)(table, refTable),
                    source: param.source,
                    sqlMgr
                });
            }
            await ((_param_columnWebhookManager = param.columnWebhookManager) == null ? void 0 : _param_columnWebhookManager.addNewColumnById({
                columnId: parentRelCol.id,
                action: _nocodbsdk.WebhookActions.INSERT,
                context: _extends({}, context, {
                    base_id: parentRelCol.base_id
                })
            }));
            await ((_param_columnWebhookManager1 = param.columnWebhookManager) == null ? void 0 : _param_columnWebhookManager1.addNewColumnById({
                columnId: savedColumn.id,
                action: _nocodbsdk.WebhookActions.INSERT,
                context: _extends({}, context, {
                    base_id: savedColumn.base_id
                })
            }));
            return savedColumn;
        }
    }
    async createColumnIndex(context, { column, sqlMgr, source, indexName = null, nonUnique = true }) {
        // TODO: implement for snowflake (right now create index does not work with identifier quoting in snowflake - bug?)
        if (source.type === 'snowflake') return;
        const model = await column.getModel(context);
        const indexArgs = {
            columns: [
                column.column_name
            ],
            tn: model.table_name,
            non_unique: nonUnique,
            indexName
        };
        await sqlMgr.sqlOpPlus(source, 'indexCreate', indexArgs);
    }
    async updateRollupOrLookup(context, colBody, column) {
        // Validate rollup or lookup payload before proceeding with the update
        if (_nocodbsdk.UITypes.Lookup === column.uidt && (0, _helpers.validateRequiredField)(colBody, [
            'fk_lookup_column_id',
            'fk_relation_column_id'
        ])) {
            // Perform additional validation for lookup payload
            await (0, _helpers.validateLookupPayload)(context, colBody, column.id);
            await _models.Column.update(context, column.id, colBody);
        } else if (_nocodbsdk.UITypes.Rollup === column.uidt && (0, _helpers.validateRequiredField)(colBody, [
            'fk_relation_column_id',
            'fk_rollup_column_id',
            'rollup_function'
        ])) {
            // Perform additional validation for rollup payload
            await (0, _helpers.validateRollupPayload)(context, colBody);
            const baseModel = await (0, _dbHelpers.getBaseModelSqlFromModelId)({
                modelId: column.fk_model_id,
                context
            });
            await (0, _genRollupSelectv2.default)({
                baseModelSqlv2: baseModel,
                knex: baseModel.dbDriver,
                columnOptions: _extends({
                    // colBody do not have fk_column_id
                    // fk_column_id is required to detect circular ref
                    fk_column_id: column.colOptions.fk_column_id
                }, colBody)
            });
            await _models.Column.update(context, column.id, colBody);
        }
    }
    async columnsHash(context, tableId) {
        const table = await _models.Model.getWithInfo(context, {
            id: tableId
        });
        if (!table) {
            _catchError.NcError.get(context).tableNotFound(tableId);
        }
        return {
            hash: table.columnsHash
        };
    }
    async columnBulk(context, tableId, params, req) {
        // TODO validatePayload
        const table = await _models.Model.getWithInfo(context, {
            id: tableId
        });
        if (!table) {
            _catchError.NcError.get(context).tableNotFound(tableId);
        }
        if (table.columnsHash !== params.hash) {
            _catchError.NcError.get(context).outOfSync('Columns are updated by someone else! Your changes are rejected. Please refresh the page and try again.');
        }
        const source = await _models.Source.get(context, table.source_id);
        if (!source) {
            _catchError.NcError.get(context).sourceNotFound(table.source_id);
        }
        const base = await source.getProject(context);
        if (!base) {
            _catchError.NcError.get(context).baseNotFound(source.base_id);
        }
        const dbDriver = await _NcConnectionMgrv2.default.get(source);
        const sqlClient = await _NcConnectionMgrv2.default.getSqlClient(source);
        const sqlMgr = await _ProjectMgrv2.default.getSqlMgr(context, {
            id: source.base_id
        });
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: table.id,
            dbDriver: dbDriver
        });
        if (!dbDriver || !sqlClient || !sqlMgr || !baseModel) {
            _catchError.NcError.get(context).badRequest('There was an error handling your request');
        }
        const reuse = {
            table,
            source,
            base,
            dbDriver,
            sqlClient,
            sqlMgr,
            baseModel
        };
        const ops = params.ops;
        for (const op of ops){
            if (op.op === 'update') {
                var _op_column;
                if (!op.column || !((_op_column = op.column) == null ? void 0 : _op_column.id)) {
                    _catchError.NcError.get(context).badRequest('Bad request, update operation requires column id');
                }
            } else if (op.op === 'delete') {
                var _op_column1;
                if (!op.column || !((_op_column1 = op.column) == null ? void 0 : _op_column1.id)) {
                    _catchError.NcError.get(context).badRequest('Bad request, delete operation requires column id');
                }
            } else if (op.op === 'add') {
                if (!op.column) {
                    _catchError.NcError.get(context).badRequest('Bad request, add operation requires column');
                }
            }
        }
        const failedOps = [];
        // Perform operations in a loop, capturing any errors for individual operations
        for (const op of ops){
            const column = op.column;
            if (op.op === 'add') {
                try {
                    const tableMeta = await this.columnAdd(context, {
                        tableId,
                        column: column,
                        req,
                        user: req.user,
                        reuse
                    });
                    await this.postColumnAdd(context, column, tableMeta);
                } catch (e) {
                    const dbError = _extractor.DBErrorExtractor.get().extractDbError(e, {
                        clientType: source.type
                    });
                    failedOps.push(_extends({}, op, {
                        error: (dbError == null ? void 0 : dbError.message) || e.message
                    }));
                }
            } else if (op.op === 'update') {
                try {
                    await this.columnUpdate(context, {
                        columnId: op.column.id,
                        column: column,
                        req,
                        user: req.user,
                        reuse
                    });
                    await this.postColumnUpdate(context, column);
                } catch (e) {
                    const dbError = _extractor.DBErrorExtractor.get().extractDbError(e, {
                        clientType: source.type
                    });
                    failedOps.push(_extends({}, op, {
                        error: (dbError == null ? void 0 : dbError.message) || e.message
                    }));
                }
            } else if (op.op === 'delete') {
                try {
                    await this.columnDelete(context, {
                        columnId: op.column.id,
                        req,
                        user: req.user
                    });
                } catch (e) {
                    const dbError = _extractor.DBErrorExtractor.get().extractDbError(e, {
                        clientType: source.type
                    });
                    failedOps.push(_extends({}, op, {
                        error: (dbError == null ? void 0 : dbError.message) || e.message
                    }));
                }
            }
        }
        return {
            failedOps
        };
    }
    async postColumnAdd(_context, _columnBody, _tableMeta) {
    // placeholder for post column add hook
    }
    async postColumnUpdate(_context, _columnBody) {
    // placeholder for post column update hook
    }
    async checkCrossBasePermission(refContext, user) {
        var _userWithRoles_base_roles, _userWithRoles_base_roles1;
        // extract target base roles and check if columnAdd permission is granted
        const userWithRoles = await _models.User.getWithRoles(refContext, user.id, {
            baseId: refContext.base_id,
            workspaceId: refContext.workspace_id
        });
        if (!userWithRoles) {
            _catchError.NcError.get(refContext).userNotFound(user.id);
        }
        if (!((_userWithRoles_base_roles = userWithRoles.base_roles) == null ? void 0 : _userWithRoles_base_roles[_nocodbsdk.ProjectRoles.CREATOR]) && !((_userWithRoles_base_roles1 = userWithRoles.base_roles) == null ? void 0 : _userWithRoles_base_roles1[_nocodbsdk.ProjectRoles.OWNER])) {
            _catchError.NcError.get(refContext).forbidden(`You don't have permission to create a relation to target base ${refContext.base_id}`);
        }
    }
    async deleteCustomLinkIndex(_context, _) {
    // placeholder for delete custom link index
    }
    async getLinkColumnRefTable(context, { columnId, tableId, user }) {
        const column = await _models.Column.get(context, {
            colId: columnId
        });
        // if not LTAR or Links throw error
        if (!(0, _nocodbsdk.isLinksOrLTAR)(column)) {
            _catchError.NcError.get(context).badRequest('Invalid column id');
        }
        const colOptions = await column.getColOptions(context);
        let table;
        const { refContext, mmContext } = colOptions.getRelContext(context);
        if (colOptions.fk_mm_model_id === tableId) {
            table = await colOptions.getMMModel(mmContext);
            // load columns
            await table.getColumns(mmContext);
        } else if (colOptions.fk_related_model_id === tableId) {
            table = await colOptions.getRelatedTable(refContext);
            // load columns
            await table.getColumns(refContext);
        } else {
            _catchError.NcError.get(context).badRequest('Invalid table id');
        }
        // filter out columns other than primary key and display column
        table.columns = table.columns.filter((col)=>{
            return col.pk || col.pv;
        });
        // Check table visibility access and add flag
        let is_private = false;
        if (user && !(0, _nocodbsdk.isServiceUser)(user)) {
            const baseRoles = (0, _nocodbsdk.extractRolesObj)(user == null ? void 0 : user.base_roles);
            // Base owners always have access
            if (!(baseRoles == null ? void 0 : baseRoles[_nocodbsdk.ProjectRoles.OWNER])) {
                const permissions = await _models.Permission.list(context, table.base_id);
                const visibilityPermission = permissions.find((p)=>p.entity === _nocodbsdk.PermissionEntity.TABLE && p.entity_id === tableId && p.permission === _nocodbsdk.PermissionKey.TABLE_VISIBILITY);
                if (visibilityPermission) {
                    // Get the user's project role (base role)
                    const userRole = (0, _nocodbsdk.getProjectRole)(user);
                    if (!userRole) {
                        is_private = true;
                    } else {
                        // Check if user has permission
                        // Type assertion needed because isAllowed is defined in EE Permission model
                        const hasPermission = await _models.Permission.isAllowed(context, visibilityPermission, {
                            id: user.id,
                            role: userRole
                        });
                        if (!hasPermission) {
                            is_private = true;
                        }
                    }
                }
            }
        }
        // Add is_private flag to table object
        return _extends({}, table, {
            is_private
        });
    }
    constructor(metaService, appHooksService, formulaColumnTypeChanger, viewRowColorService, filtersService, metaDependencyEventHandler, duplicateDetectionService){
        this.metaService = metaService;
        this.appHooksService = appHooksService;
        this.formulaColumnTypeChanger = formulaColumnTypeChanger;
        this.viewRowColorService = viewRowColorService;
        this.filtersService = filtersService;
        this.metaDependencyEventHandler = metaDependencyEventHandler;
        this.duplicateDetectionService = duplicateDetectionService;
        this.logger = new _common.Logger(ColumnsService.name);
        this.deleteHmOrBtRelation = async (context, { relationColOpt, source, childColumn, childTable, parentColumn, parentTable, sqlMgr, ncMeta = _Noco.default.ncMeta, virtual, custom = false, req, parentContext, childContext, column, columnWebhookManager }, ignoreFkDelete = false)=>{
            var _column_meta;
            if (childTable && !custom) {
                let foreignKeyName;
                // if relationColOpt is not provided, extract it from child table
                // and get the foreign key name for dropping the foreign key
                if (!relationColOpt) {
                    var _this;
                    foreignKeyName = ((_this = await childTable.getColumns(childContext, ncMeta).then(async (cols)=>{
                        for (const col of cols){
                            if (col.uidt === _nocodbsdk.UITypes.LinkToAnotherRecord) {
                                const colOptions = await col.getColOptions(childContext, ncMeta);
                                if (colOptions.fk_related_model_id === parentTable.id) {
                                    return {
                                        colOptions
                                    };
                                }
                            }
                        }
                    })) == null ? void 0 : _this.colOptions).fk_index_name;
                } else {
                    foreignKeyName = relationColOpt.fk_index_name;
                }
                if (!(relationColOpt == null ? void 0 : relationColOpt.virtual) && !virtual) {
                    // Ensure relation deletion is not attempted for virtual relations
                    try {
                        const childSource = childColumn.source_id === source.id ? source : await _models.Source.get(childContext, childColumn.source_id);
                        // Attempt to delete the foreign key constraint from the database
                        await sqlMgr.sqlOpPlus(childSource, 'relationDelete', {
                            childColumn: childColumn.column_name,
                            childTable: childTable.table_name,
                            parentTable: parentTable.table_name,
                            parentColumn: parentColumn.column_name,
                            foreignKeyName
                        });
                    } catch (e) {
                        console.log(e.message);
                    }
                }
            }
            if (!relationColOpt) return;
            const { refContext } = relationColOpt.getRelContext(context);
            const refTable = await relationColOpt.getRelatedTable(refContext, ncMeta);
            const columnsInRelatedTable = await refTable.getColumns(refContext, ncMeta);
            const relType = relationColOpt.type === 'bt' ? 'hm' : 'bt';
            for (const c of columnsInRelatedTable){
                if (!(0, _nocodbsdk.isLinksOrLTAR)(c.uidt)) continue;
                const colOpt = await c.getColOptions(refContext, ncMeta);
                if (colOpt.fk_parent_column_id === parentColumn.id && colOpt.fk_child_column_id === childColumn.id && colOpt.type === relType) {
                    const colInRefTable = await _models.Column.get(refContext, {
                        colId: c.id
                    }, ncMeta);
                    await (columnWebhookManager == null ? void 0 : columnWebhookManager.addOldColumnById({
                        columnId: c.id,
                        action: _nocodbsdk.WebhookActions.DELETE,
                        context: refContext
                    }));
                    await _models.Column.delete2(refContext, _extends({
                        id: c.id
                    }, generateColumnDeleteHandler(columnWebhookManager)), ncMeta);
                    if (!colInRefTable.system) {
                        this.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_DELETE, {
                            table: refTable,
                            column: colInRefTable,
                            req,
                            context: refContext,
                            columnId: colInRefTable.id,
                            columns: await refTable.getColumns(context)
                        });
                    }
                    break;
                }
            }
            await (columnWebhookManager == null ? void 0 : columnWebhookManager.addOldColumnById({
                columnId: relationColOpt.fk_column_id,
                action: _nocodbsdk.WebhookActions.DELETE
            }));
            // delete virtual columns
            await _models.Column.delete2(context, _extends({
                id: relationColOpt.fk_column_id
            }, generateColumnDeleteHandler(columnWebhookManager)), ncMeta);
            const isBt = relationColOpt.type === _nocodbsdk.RelationTypes.BELONGS_TO || relationColOpt.type === _nocodbsdk.RelationTypes.ONE_TO_ONE && ((_column_meta = column.meta) == null ? void 0 : _column_meta.bt);
            const col = isBt ? childColumn : parentColumn;
            const table = isBt ? childTable : parentTable;
            const delContext = isBt ? childContext : parentContext;
            if (!col.system) {
                this.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_DELETE, {
                    table,
                    column: col,
                    req: req,
                    context: delContext,
                    columnId: col.id,
                    columns: await table.getColumns(delContext)
                });
            }
            if (custom) return;
            if (!ignoreFkDelete && childColumn.uidt === _nocodbsdk.UITypes.ForeignKey) {
                const cTable = await _models.Model.getWithInfo(childContext, {
                    id: childTable.id
                }, ncMeta);
                const childSource = childColumn.source_id === source.id ? source : await _models.Source.get(childContext, childColumn.source_id);
                // if virtual column delete all index before deleting the column
                if (relationColOpt == null ? void 0 : relationColOpt.virtual) {
                    var _ref;
                    var _data, _this1;
                    const indexes = (_ref = (_this1 = await sqlMgr.sqlOp(childSource, 'indexList', {
                        tn: cTable.table_name
                    })) == null ? void 0 : (_data = _this1.data) == null ? void 0 : _data.list) != null ? _ref : [];
                    for (const index of indexes){
                        if (index.cn !== childColumn.column_name) continue;
                        await sqlMgr.sqlOpPlus(childSource, 'indexDelete', _extends({}, index, {
                            tn: cTable.table_name,
                            columns: [
                                childColumn.column_name
                            ],
                            indexName: index.key_name
                        }));
                    }
                }
                const tableUpdateBody = _extends({}, cTable, {
                    tn: cTable.table_name,
                    originalColumns: cTable.columns.map((c)=>_extends({}, c, {
                            cn: c.column_name,
                            cno: c.column_name
                        })),
                    columns: cTable.columns.map((c)=>{
                        if (c.id === childColumn.id) {
                            return _extends({}, c, {
                                cn: c.column_name,
                                cno: c.column_name,
                                altered: 4
                            });
                        } else {
                            c.cn = c.column_name;
                        }
                        return c;
                    })
                });
                await sqlMgr.sqlOpPlus(childSource, 'tableUpdate', tableUpdateBody);
                await (columnWebhookManager == null ? void 0 : columnWebhookManager.addOldColumnById({
                    columnId: childColumn.id,
                    action: _nocodbsdk.WebhookActions.DELETE,
                    context: childContext
                }));
                // delete foreign key column
                await _models.Column.delete2(childContext, _extends({
                    id: childColumn.id
                }, generateColumnDeleteHandler(columnWebhookManager)), ncMeta);
            }
        };
        this.deleteOoRelation = async (context, { relationColOpt, source, childColumn, childTable, parentColumn, parentTable, sqlMgr, ncMeta = _Noco.default.ncMeta, virtual, custom = false, req, childContext, parentContext, column, columnWebhookManager }, ignoreFkDelete = false)=>{
            var _column_meta;
            const childSource = childColumn.source_id === source.id ? source : await _models.Source.get(childContext, childColumn.source_id);
            if (childTable) {
                if (!custom) {
                    let foreignKeyName;
                    // if relationColOpt is not provided, extract it from child table
                    // and get the foreign key name for dropping the foreign key
                    if (!relationColOpt) {
                        var _this;
                        foreignKeyName = ((_this = await childTable.getColumns(childContext, ncMeta).then(async (cols)=>{
                            for (const col of cols){
                                if (col.uidt === _nocodbsdk.UITypes.LinkToAnotherRecord) {
                                    const colOptions = await col.getColOptions(childContext, ncMeta);
                                    if (colOptions.fk_related_model_id === parentTable.id) {
                                        return {
                                            colOptions
                                        };
                                    }
                                }
                            }
                        })) == null ? void 0 : _this.colOptions).fk_index_name;
                    } else {
                        foreignKeyName = relationColOpt.fk_index_name;
                    }
                    if (!(relationColOpt == null ? void 0 : relationColOpt.virtual) && !virtual) {
                        // Ensure relation deletion is not attempted for virtual relations
                        try {
                            // Attempt to delete the foreign key constraint from the database
                            await sqlMgr.sqlOpPlus(childSource, 'relationDelete', {
                                childColumn: childColumn.column_name,
                                childTable: childTable.table_name,
                                parentTable: parentTable.table_name,
                                parentColumn: parentColumn.column_name,
                                foreignKeyName
                            });
                        } catch (e) {
                            console.log(e.message);
                        }
                    }
                }
            }
            if (!relationColOpt) return;
            const { refContext } = relationColOpt.getRelContext(context);
            const refTable = await relationColOpt.getRelatedTable(refContext, ncMeta);
            const columnsInRelatedTable = await refTable.getCachedColumns(refContext);
            const relType = _nocodbsdk.RelationTypes.ONE_TO_ONE;
            for (const c of columnsInRelatedTable){
                if (c.uidt !== _nocodbsdk.UITypes.LinkToAnotherRecord) continue;
                const colOpt = await c.getColOptions(refContext, ncMeta);
                if (colOpt.fk_parent_column_id === parentColumn.id && colOpt.fk_child_column_id === childColumn.id && colOpt.type === relType) {
                    const colInRefTable = await _models.Column.get(refContext, {
                        colId: c.id
                    }, ncMeta);
                    await (columnWebhookManager == null ? void 0 : columnWebhookManager.addOldColumnById({
                        columnId: c.id,
                        action: _nocodbsdk.WebhookActions.DELETE,
                        context: refContext
                    }));
                    await _models.Column.delete2(refContext, _extends({
                        id: c.id
                    }, generateColumnDeleteHandler(columnWebhookManager)), ncMeta);
                    if (!colInRefTable.system) {
                        this.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_DELETE, {
                            table: refTable,
                            column: colInRefTable,
                            req,
                            context: refContext,
                            columnId: colInRefTable.id,
                            columns: await refTable.getColumns(context)
                        });
                    }
                    break;
                }
            }
            await (columnWebhookManager == null ? void 0 : columnWebhookManager.addOldColumnById({
                columnId: relationColOpt.fk_column_id,
                action: _nocodbsdk.WebhookActions.DELETE,
                context
            }));
            // delete virtual columns
            await _models.Column.delete2(context, _extends({
                id: relationColOpt.fk_column_id
            }, generateColumnDeleteHandler(columnWebhookManager)), ncMeta);
            const isBt = (_column_meta = column.meta) == null ? void 0 : _column_meta.bt;
            const col = isBt ? childColumn : parentColumn;
            const table = isBt ? childTable : parentTable;
            const delContext = isBt ? childContext : parentContext;
            if (!col.system) {
                this.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_DELETE, {
                    table,
                    column: col,
                    req: req,
                    context: delContext,
                    columnId: col.id,
                    columns: await table.getColumns(context)
                });
            }
            if (custom) return;
            if (!ignoreFkDelete && childColumn.uidt === _nocodbsdk.UITypes.ForeignKey) {
                const cTable = await _models.Model.getWithInfo(context, {
                    id: childTable.id
                }, ncMeta);
                // if virtual column delete all index before deleting the column
                if (relationColOpt == null ? void 0 : relationColOpt.virtual) {
                    var _ref;
                    var _data, _this1;
                    const indexes = (_ref = (_this1 = await sqlMgr.sqlOp(childSource, 'indexList', {
                        tn: cTable.table_name
                    })) == null ? void 0 : (_data = _this1.data) == null ? void 0 : _data.list) != null ? _ref : [];
                    for (const index of indexes){
                        if (index.cn !== childColumn.column_name) continue;
                        await sqlMgr.sqlOpPlus(childSource, 'indexDelete', _extends({}, index, {
                            tn: cTable.table_name,
                            columns: [
                                childColumn.column_name
                            ],
                            indexName: index.key_name
                        }));
                    }
                }
                const tableUpdateBody = _extends({}, cTable, {
                    tn: cTable.table_name,
                    originalColumns: cTable.columns.map((c)=>_extends({}, c, {
                            cn: c.column_name,
                            cno: c.column_name
                        })),
                    columns: cTable.columns.map((c)=>{
                        if (c.id === childColumn.id) {
                            return _extends({}, c, {
                                cn: c.column_name,
                                cno: c.column_name,
                                altered: 4
                            });
                        } else {
                            c.cn = c.column_name;
                        }
                        return c;
                    })
                });
                await sqlMgr.sqlOpPlus(childSource, 'tableUpdate', tableUpdateBody);
                await (columnWebhookManager == null ? void 0 : columnWebhookManager.addOldColumnById({
                    columnId: childColumn.id,
                    action: _nocodbsdk.WebhookActions.DELETE,
                    context: childContext
                }));
                // delete foreign key column
                await _models.Column.delete2(childContext, _extends({
                    id: childColumn.id
                }, generateColumnDeleteHandler(columnWebhookManager)), ncMeta);
            }
        };
    }
};
ColumnsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(2, (0, _common.Inject)((0, _common.forwardRef)(()=>'FormulaColumnTypeChanger'))),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _metaservice.MetaService === "undefined" ? Object : _metaservice.MetaService,
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService,
        typeof _formulacolumntypechangertypes.IFormulaColumnTypeChanger === "undefined" ? Object : _formulacolumntypechangertypes.IFormulaColumnTypeChanger,
        typeof _viewrowcolorservice.ViewRowColorService === "undefined" ? Object : _viewrowcolorservice.ViewRowColorService,
        typeof _filtersservice.FiltersService === "undefined" ? Object : _filtersservice.FiltersService,
        typeof _eventhandlerservice.MetaDependencyEventHandler === "undefined" ? Object : _eventhandlerservice.MetaDependencyEventHandler,
        typeof _duplicatedetectionservice.DuplicateDetectionService === "undefined" ? Object : _duplicatedetectionservice.DuplicateDetectionService
    ])
], ColumnsService);
